(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-events"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.about-events__grid').forEach((el) => {
    if (typeof Swiper === 'undefined') return;

    new Swiper(el, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      grabCursor: true,
      a11y: { enabled: true },
      pagination: {
        el: el.querySelector('.about-events__pagination'),
        clickable: true
      },
      breakpoints: {
        990: { slidesPerView: 5, spaceBetween: 24 }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-article-header]').forEach((header) => {
    const copyBtn = header.querySelector('[data-share-copy]');
    if (copyBtn) {
      const defaultLabel = copyBtn.getAttribute('aria-label');
      copyBtn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          copyBtn.setAttribute('aria-label', copyBtn.getAttribute('data-copied-label') || '¡Enlace copiado!');
          copyBtn.classList.add('is-copied');
          setTimeout(() => {
            copyBtn.setAttribute('aria-label', defaultLabel);
            copyBtn.classList.remove('is-copied');
          }, 2000);
        } catch (e) {
          /* clipboard unavailable */
        }
      });
    }

    const readingEl = header.querySelector('[data-reading-time]');
    const body = document.querySelector('.article-body');
    if (readingEl && body) {
      const speed = parseInt(header.getAttribute('data-reading-speed'), 10) || 200;
      const words = body.innerText.trim().split(/\s+/).filter(Boolean).length;
      const minutes = Math.max(1, Math.round(words / speed));
      const template = readingEl.getAttribute('data-reading-template') || readingEl.textContent;
      readingEl.textContent = template.replace(/\d+/, minutes);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-filters"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-blog-filters]').forEach((root) => {
    const blogUrl = root.getAttribute('data-blog-url');
    const basePath = new URL(blogUrl, window.location.origin).pathname.replace(/\/$/, '');
    const select = root.querySelector('[data-blog-category]');
    const searchBtn = root.querySelector('[data-blog-search]');

    // Styled listbox mirroring the hidden native select.
    const dropdown = root.querySelector('[data-blog-category-control]');
    const toggle = root.querySelector('[data-blog-category-toggle]');
    const menu = root.querySelector('[data-blog-category-menu]');
    const valueEl = root.querySelector('[data-blog-category-value]');
    const options = menu ? Array.from(menu.querySelectorAll('[data-blog-category-option]')) : [];
    const placeholder = select && select.options[0] ? select.options[0].textContent.trim() : '';

    function closeMenu() {
      if (!menu || menu.hidden) return;
      menu.hidden = true;
      dropdown.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    function openMenu() {
      if (!menu) return;
      menu.hidden = false;
      dropdown.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      const current = options.find((el) => el.getAttribute('aria-selected') === 'true');
      (current || options[0])?.focus();
    }

    // Reflect the select's value on the styled control.
    function syncDropdown() {
      if (!menu || !select) return;
      const value = select.value;
      options.forEach((el) => {
        el.setAttribute('aria-selected', el.getAttribute('data-value') === value ? 'true' : 'false');
      });
      const selected = select.selectedOptions[0];
      valueEl.textContent = value && selected ? selected.textContent.trim() : placeholder;
    }

    function chooseOption(el) {
      const value = el.getAttribute('data-value');
      const isSelected = el.getAttribute('aria-selected') === 'true';
      closeMenu();
      toggle.focus();
      select.value = isSelected ? '' : value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (toggle && menu) {
      toggle.addEventListener('click', () => {
        if (menu.hidden) {
          openMenu();
        } else {
          closeMenu();
        }
      });

      options.forEach((el, index) => {
        el.addEventListener('click', () => chooseOption(el));
        el.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            chooseOption(el);
          } else if (event.key === 'ArrowDown') {
            event.preventDefault();
            options[(index + 1) % options.length].focus();
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            options[(index - 1 + options.length) % options.length].focus();
          } else if (event.key === 'Escape') {
            closeMenu();
            toggle.focus();
          }
        });
      });

      toggle.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openMenu();
        } else if (event.key === 'Escape') {
          closeMenu();
        }
      });

      document.addEventListener('click', (event) => {
        if (!dropdown.contains(event.target)) closeMenu();
      });

      select.addEventListener('change', syncDropdown);
      syncDropdown();
    }

    function buildUrl(handle) {
      return handle ? basePath + '/tagged/' + handle : basePath;
    }

    // Current handle from the address bar (e.g. /blogs/news/tagged/kaba).
    function currentHandle() {
      const match = window.location.pathname.match(/\/tagged\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    }

    // Sync pills, select and the active-tag chip to the given handle.
    function syncControls(handle) {
      let rawLabel = '';

      root.querySelectorAll('[data-blog-brand]').forEach((pill) => {
        const active = pill.getAttribute('data-brand-tag') === handle && handle !== '';
        pill.classList.toggle('active', active);
        pill.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) {
          rawLabel = pill.getAttribute('data-brand-raw') || '';
        }
      });

      if (select) {
        select.value = handle;
        if (select.value !== handle) {
          select.value = '';
        }
        if (!rawLabel && select.selectedOptions[0] && select.value) {
          rawLabel = select.selectedOptions[0].getAttribute('data-tag') || select.selectedOptions[0].textContent.trim();
        }
      }

      syncDropdown();
      renderChip(handle, rawLabel);
    }

    function renderChip(handle, rawLabel) {
      const inner = root.querySelector('.blog-filters__inner');
      let wrap = root.querySelector('[data-blog-active-wrap]');

      if (!handle) {
        if (wrap) wrap.remove();
        return;
      }

      const label = rawLabel || handle;
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'blog-filters__active';
        wrap.setAttribute('data-blog-active-wrap', '');
        wrap.setAttribute('aria-live', 'polite');
        const labelEl = document.createElement('span');
        labelEl.className = 'blog-filters__active-label';
        labelEl.textContent = root.getAttribute('data-filtered-label') || '';
        wrap.appendChild(labelEl);
        const chipEl = document.createElement('div');
        chipEl.className = 'blog-filters__active-tag';
        chipEl.setAttribute('data-blog-active-tag', '');
        wrap.appendChild(chipEl);
        inner.appendChild(wrap);
      }
      const chip = wrap.querySelector('[data-blog-active-tag]');
      chip.innerHTML =
        '<span></span>' +
        '<button type="button" class="blog-filters__active-tag-x" data-blog-clear aria-label="Remove filter">' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" /></svg>' +
        '</button>';
      chip.querySelector('span').textContent = label;
    }

    let loading = false;

    async function filter(handle, push) {
      if (loading) return;
      const targetUrl = buildUrl(handle);
      const content = document.querySelector('[data-articles-content]');
      if (!content) {
        window.location.href = targetUrl;
        return;
      }

      loading = true;
      content.classList.add('is-loading');
      content.setAttribute('aria-busy', 'true');

      try {
        const res = await fetch(targetUrl, { headers: { 'X-Requested-With': 'fetch' } });
        if (!res.ok) throw new Error('Request failed');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-articles-content]');
        if (!next) throw new Error('Content missing');

        content.innerHTML = next.innerHTML;
        if (push !== false) {
          window.history.pushState({ blogHandle: handle }, '', targetUrl);
        }
        syncControls(handle);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (err) {
        window.location.href = targetUrl;
      } finally {
        loading = false;
        content.classList.remove('is-loading');
        content.removeAttribute('aria-busy');
      }
    }

    // Append next page (load more) without reload.
    async function loadMore(link) {
      if (loading) return;
      loading = true;
      const grid = document.querySelector('[data-articles-grid]');
      const wrap = link.closest('.blog-articles__load-more-wrap');
      link.classList.add('is-loading');

      try {
        const res = await fetch(link.href, { headers: { 'X-Requested-With': 'fetch' } });
        if (!res.ok) throw new Error('Request failed');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-articles-grid]');
        const newNext = doc.querySelector('[data-articles-next]');

        if (newGrid && grid) {
          grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
        }
        if (newNext) {
          link.href = newNext.href;
        } else if (wrap) {
          wrap.remove();
        }
      } catch (err) {
        window.location.href = link.href;
      } finally {
        loading = false;
        link.classList.remove('is-loading');
      }
    }

    root.querySelectorAll('[data-blog-brand]').forEach((pill) => {
      pill.addEventListener('click', () => {
        const isActive = pill.classList.contains('active');
        filter(isActive ? '' : pill.getAttribute('data-brand-tag'));
      });
    });

    if (select) {
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        filter(option ? option.value : '');
      });
    }

    if (searchBtn && select) {
      searchBtn.addEventListener('click', () => {
        const option = select.selectedOptions[0];
        filter(option ? option.value : '');
      });
    }

    // Clear chip + load-more (event-delegated, they are re-rendered dynamically).
    document.addEventListener('click', (event) => {
      const clear = event.target.closest('[data-blog-clear]');
      if (clear && root.contains(clear)) {
        event.preventDefault();
        filter('');
        return;
      }
      const next = event.target.closest('[data-articles-next]');
      if (next) {
        event.preventDefault();
        loadMore(next);
      }
    });

    window.addEventListener('popstate', () => {
      filter(currentHandle(), false);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-recommended-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-blog-rec-products]').forEach((section) => {
    const el = section.querySelector('.blog-rec-products__swiper');
    if (!el || typeof Swiper === 'undefined') return;
    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      grabCursor: true,
      a11y: { enabled: true },
      navigation: {
        nextEl: section.querySelector('.blog-rec-products__arrow--next'),
        prevEl: section.querySelector('.blog-rec-products__arrow--prev'),
      },
      pagination: {
        el: section.querySelector('.blog-rec-products__pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
          pagination: { enabled: false },
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const root = document.querySelector('cart-drawer');
    if (!root) return;

    const body = root.querySelector('[data-cart-drawer-body]');
    let itemCount = parseInt(root.dataset.itemCount || '0', 10);
    let recProductId = root.dataset.lastProductId || null;
    let busy = false;

    function syncHeaderCount() {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = itemCount;
        el.hidden = itemCount <= 0;
      });
    }

    // Rebuy Smart Cart: whenever the Rebuy script has loaded, every "open cart"
    // goes to Rebuy instead of this drawer. Rebuy opens itself on cart links and
    // /cart/add.js calls, so this drawer must step aside or both would show.
    // If Rebuy isn't available, this drawer keeps working as fallback.
    function rebuyReady() {
      return (
        window.Rebuy &&
        window.Rebuy.SmartCart &&
        typeof window.Rebuy.SmartCart.show === 'function'
      );
    }

    function openRebuy() {
      try {
        const cartApi = window.Rebuy.Cart;
        const pending =
          cartApi && typeof cartApi.fetchCart === 'function' ? cartApi.fetchCart() : null;
        Promise.resolve(pending)
          .catch(() => {})
          .then(() => window.Rebuy.SmartCart.show());
        return true;
      } catch (err) {
        return false;
      }
    }

    // Keep the header counter in sync with changes made inside Rebuy's cart.
    document.addEventListener('rebuy:cart.change', () => {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          itemCount = cart.item_count;
          syncHeaderCount();
        })
        .catch(() => {});
    });

    // If Rebuy opens on its own (e.g. it loaded after this drawer opened),
    // close this one so only one cart is visible.
    document.addEventListener('rebuy:smartcart.show', () => closeDrawer());

    function openDrawer() {
      if (rebuyReady() && openRebuy()) return;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    async function refreshDrawer() {
      const sep = window.location.search ? '&' : '?';
      const url =
        itemCount > 0 && recProductId
          ? '/recommendations/products?section_id=cart-drawer&product_id=' + recProductId + '&limit=4&intent=complementary'
          : window.location.pathname + window.location.search + sep + 'section_id=cart-drawer';

      let html;
      try {
        html = await fetch(url).then((r) => r.text());
      } catch (err) {
        return;
      }

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newRoot = doc.querySelector('cart-drawer');
      if (!newRoot) return;

      itemCount = parseInt(newRoot.dataset.itemCount || '0', 10);
      recProductId = newRoot.dataset.lastProductId || recProductId;

      const newBody = newRoot.querySelector('[data-cart-drawer-body]');
      if (newBody && body) body.innerHTML = newBody.innerHTML;

      const existingFooter = root.querySelector('[data-cart-drawer-footer]');
      const newFooter = newRoot.querySelector('[data-cart-drawer-footer]');
      if (newFooter) {
        if (existingFooter) existingFooter.replaceWith(newFooter);
        else body.insertAdjacentElement('afterend', newFooter);
      } else if (existingFooter) {
        existingFooter.remove();
      }

      syncHeaderCount();
    }

    async function addToCart(variantId, productId, sourceBtn) {
      if (!variantId || busy) return;
      busy = true;
      if (sourceBtn) sourceBtn.classList.add('loading');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('add failed');
        recProductId = productId || recProductId;
        itemCount += 1;
        await refreshDrawer();
        openDrawer();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (err) {
        // Network/validation error — leave the UI as-is, nothing was added.
      } finally {
        busy = false;
        if (sourceBtn) sourceBtn.classList.remove('loading');
      }
    }

    async function handleAlreadyAdded(productId) {
      if (busy) return;
      recProductId = productId || recProductId;
      itemCount += 1;
      if (rebuyReady() && openRebuy()) {
        syncHeaderCount();
        return;
      }
      await refreshDrawer();
      openDrawer();
    }

    async function changeQuantity(key, quantity) {
      if (!key || busy) return;
      busy = true;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        await refreshDrawer();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (err) {
        // no-op
      } finally {
        busy = false;
      }
    }

    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cart-drawer-open]');
      if (opener) {
        e.preventDefault();
        if (rebuyReady() && openRebuy()) return;
        refreshDrawer().then(openDrawer);
        return;
      }

      const closer = e.target.closest('[data-cart-drawer-close]');
      if (closer) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      const quickAdd = e.target.closest('[data-add-to-cart]');
      if (quickAdd) {
        e.preventDefault();
        addToCart(quickAdd.dataset.variantId, quickAdd.dataset.productId, quickAdd);
        return;
      }

      const minusBtn = e.target.closest('[data-cart-qty-minus]');
      if (minusBtn) {
        const li = minusBtn.closest('[data-cart-item]');
        const valueEl = li.querySelector('[data-cart-qty-value]');
        const next = Math.max(0, parseInt(valueEl.textContent, 10) - 1);
        changeQuantity(li.dataset.key, next);
        return;
      }

      const plusBtn = e.target.closest('[data-cart-qty-plus]');
      if (plusBtn) {
        const li = plusBtn.closest('[data-cart-item]');
        const valueEl = li.querySelector('[data-cart-qty-value]');
        const next = parseInt(valueEl.textContent, 10) + 1;
        changeQuantity(li.dataset.key, next);
        return;
      }

      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        const li = removeBtn.closest('[data-cart-item]');
        changeQuantity(li.dataset.key, 0);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
    });

    document.addEventListener('cart:item-added', (e) => {
      handleAlreadyAdded(e.detail && e.detail.productId);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('.qty-stepper').forEach((stepper) => {
    const minus = stepper.querySelector('.qty-stepper__btn--minus');
    const plus = stepper.querySelector('.qty-stepper__btn--plus');
    const input = stepper.querySelector('.qty-stepper__input');

    minus.addEventListener('click', () => {
      const next = Math.max(0, parseInt(input.value, 10) - 1);
      input.value = next;
      minus.disabled = next <= 1;
    });

    plus.addEventListener('click', () => {
      const next = parseInt(input.value, 10) + 1;
      input.value = next;
      minus.disabled = next <= 1;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collab-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Swiper turns loop off unless the track holds ~2x the visible slides.
    // Duplicate the originals until it does, so the loop stays seamless.
    function fillForLoop(el, wrapper, originals) {
      var slideWidth = originals[0].getBoundingClientRect().width || 1;
      var perView = Math.max(3, Math.ceil(el.clientWidth / slideWidth));
      var needed = perView * 2 + 2;
      for (var i = 0; wrapper.children.length < needed; i++) {
        var clone = originals[i % originals.length].cloneNode(true);
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('data-loop-fill', '');
        wrapper.appendChild(clone);
      }
    }

    // Own bullets: one per original image, not per (duplicated) slide.
    function buildDots(root, swiper, count) {
      var wrap = root.querySelector('[data-carousel-dots]');
      if (!wrap) return;
      wrap.innerHTML = '';
      var dots = [];
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'swiper-pagination-bullet';
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () {
            swiper.slideToLoop(idx);
          });
        })(i);
        wrap.appendChild(dot);
        dots.push(dot);
      }
      function sync() {
        var active = swiper.realIndex % count;
        dots.forEach(function (dot, i) {
          dot.classList.toggle('swiper-pagination-bullet-active', i === active);
          dot.setAttribute('aria-current', i === active ? 'true' : 'false');
        });
      }
      swiper.on('slideChange', sync);
      swiper.on('slideChangeTransitionEnd', sync);
      sync();
    }

    function initCarousel(root) {
      var el = root.querySelector('[data-carousel]');
      if (!el || typeof Swiper === 'undefined' || el.swiper) return;

      var wrapper = el.querySelector('.swiper-wrapper');
      var originals = wrapper ? Array.prototype.slice.call(wrapper.children) : [];
      var count = originals.length;
      if (!count) return;

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4;
      var canLoop = count > 1;

      if (canLoop) fillForLoop(el, wrapper, originals);

      var swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        loop: canLoop,
        grabCursor: true,
        speed: reduceMotion ? 0 : 500,
        watchSlidesProgress: true,
        a11y: { enabled: true },
        keyboard: { enabled: true, onlyInViewport: true },
        autoplay:
          autoplay && canLoop && !reduceMotion
            ? { delay: speed * 1000, pauseOnMouseEnter: true, disableOnInteraction: false }
            : false,
      });

      if (canLoop) buildDots(root, swiper, count);
    }

    function initAll(scope) {
      if (scope.matches && scope.matches('.collab-gallery[data-collab-carousel]')) initCarousel(scope);
      scope.querySelectorAll('.collab-gallery[data-collab-carousel]').forEach(initCarousel);
    }

    initAll(document);
    // Theme editor re-renders the section markup; re-init on the fresh DOM.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collab-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Swiper turns loop off unless the track holds ~2x the visible slides.
    // Duplicate the originals until it does, so the loop stays seamless.
    function fillForLoop(el, wrapper, originals) {
      var slideWidth = originals[0].getBoundingClientRect().width || 1;
      var perView = Math.max(3, Math.ceil(el.clientWidth / slideWidth));
      var needed = perView * 2 + 2;
      for (var i = 0; wrapper.children.length < needed; i++) {
        var clone = originals[i % originals.length].cloneNode(true);
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('data-loop-fill', '');
        wrapper.appendChild(clone);
      }
    }

    // Own bullets: one per original product, not per (duplicated) slide.
    function buildDots(root, swiper, count) {
      var wrap = root.querySelector('[data-carousel-dots]');
      if (!wrap) return;
      wrap.innerHTML = '';
      var dots = [];
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'swiper-pagination-bullet';
        dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () {
            swiper.slideToLoop(idx);
          });
        })(i);
        wrap.appendChild(dot);
        dots.push(dot);
      }
      function sync() {
        var active = swiper.realIndex % count;
        dots.forEach(function (dot, i) {
          dot.classList.toggle('swiper-pagination-bullet-active', i === active);
          dot.setAttribute('aria-current', i === active ? 'true' : 'false');
        });
      }
      swiper.on('slideChange', sync);
      swiper.on('slideChangeTransitionEnd', sync);
      sync();
    }

    function initCarousel(root) {
      var el = root.querySelector('[data-carousel]');
      if (!el || typeof Swiper === 'undefined' || el.swiper) return;

      var wrapper = el.querySelector('.swiper-wrapper');
      var originals = wrapper ? Array.prototype.slice.call(wrapper.children) : [];
      var count = originals.length;
      if (!count) return;

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4;
      var canLoop = count > 1;

      if (canLoop) fillForLoop(el, wrapper, originals);

      var swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        loop: canLoop,
        grabCursor: true,
        speed: reduceMotion ? 0 : 500,
        watchSlidesProgress: true,
        a11y: { enabled: true },
        keyboard: { enabled: true, onlyInViewport: true },
        navigation: {
          prevEl: root.querySelector('[data-carousel-prev]'),
          nextEl: root.querySelector('[data-carousel-next]'),
        },
        autoplay:
          autoplay && canLoop && !reduceMotion
            ? { delay: speed * 1000, pauseOnMouseEnter: true, disableOnInteraction: false }
            : false,
      });

      if (canLoop) buildDots(root, swiper, count);
    }

    function initAll(scope) {
      if (scope.matches && scope.matches('.collab-products[data-collab-carousel]')) initCarousel(scope);
      scope.querySelectorAll('.collab-products[data-collab-carousel]').forEach(initCarousel);
    }

    initAll(document);
    // Theme editor re-renders the section markup; re-init on the fresh DOM.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collab-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.collab-reviews[data-collab-carousel]').forEach(function (root) {
      if (root.dataset.carouselReady) return;
      root.dataset.carouselReady = '1';
      var track = root.querySelector('[data-carousel-track]');
      var dotsWrap = root.querySelector('[data-carousel-dots]');
      if (!track) return;

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var originalNodes = Array.prototype.slice.call(track.children);
      var originalCount = originalNodes.length;
      if (!originalCount) return;

      var canLoop = originalCount > 1;
      if (canLoop) {
        originalNodes.forEach(function (node) {
          var clone = node.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
          // Clones are decorative; strip video hooks so they never autoplay/duplicate playback.
          clone.querySelectorAll('[data-review-video], [data-review-play]').forEach(function (el) {
            el.removeAttribute('data-review-video');
            el.removeAttribute('data-review-play');
          });
          track.appendChild(clone);
        });
      }

      var cards = track.children;
      function step() {
        var s = getComputedStyle(track);
        var gap = parseFloat(s.columnGap || s.gap) || 0;
        return cards[0].getBoundingClientRect().width + gap;
      }
      function loopWidth() { return step() * originalCount; }

      function normalize() {
        if (!canLoop) return;
        var w = loopWidth();
        if (track.scrollLeft >= w) track.scrollLeft -= w;
        else if (track.scrollLeft < 0) track.scrollLeft += w;
      }

      function advance(dir) {
        if (canLoop && dir < 0 && track.scrollLeft <= 1) track.scrollLeft += loopWidth();
        track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      if (dotsWrap) {
        for (var i = 0; i < originalCount; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to review ' + (i + 1));
          (function (idx) { b.addEventListener('click', function () { track.scrollTo({ left: idx * step(), behavior: reduceMotion ? 'auto' : 'smooth' }); }); })(i);
          dotsWrap.appendChild(b);
        }
        var dots = dotsWrap.children;
        function sync() {
          var idx = Math.round(track.scrollLeft / step()) % originalCount;
          for (var j = 0; j < dots.length; j++) dots[j].setAttribute('aria-current', j === idx ? 'true' : 'false');
        }
        track.addEventListener('scroll', function () { window.requestAnimationFrame(function () { normalize(); sync(); }); });
        sync();
      } else {
        track.addEventListener('scroll', function () { window.requestAnimationFrame(normalize); });
      }

      // Mouse drag-to-scroll (desktop). Touch swipe already works natively via overflow-x/scroll-snap.
      var isDragging = false, dragMoved = false, dragStartX = 0, dragStartScroll = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isDragging = true;
        dragMoved = false;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.style.scrollSnapType = 'none';
        track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        var dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 5) dragMoved = true;
        track.scrollLeft = dragStartScroll - dx;
      });
      function endDrag() {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
        track.style.scrollSnapType = '';
        if (dragMoved) {
          var s = step();
          var idx = Math.round(track.scrollLeft / s);
          track.scrollTo({ left: idx * s, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function () { if (isDragging) endDrag(); });
      track.addEventListener('click', function (e) {
        if (dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          dragMoved = false;
        }
      }, true);

      // Autoplay (paused while a video is playing)
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4;
      var timer = null, videoPlaying = false, autoOn = autoplay && canLoop && !reduceMotion;
      function start() { if (autoOn && !timer && !videoPlaying) timer = window.setInterval(function () { advance(1); }, speed * 1000); }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      if (autoOn) {
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);
        track.addEventListener('touchstart', stop, { passive: true });
        document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
        start();
      }

      // Wire video play only on the original (non-clone) cards.
      originalNodes.forEach(function (card) {
        var btn = card.querySelector('[data-review-play]');
        var video = card.querySelector('[data-review-video]');
        if (!btn || !video) return;
        btn.addEventListener('click', function () {
          if (video.paused) {
            video.play();
            card.classList.add('is-playing');
            videoPlaying = true;
            stop();
          } else {
            video.pause();
            card.classList.remove('is-playing');
            videoPlaying = false;
            start();
          }
        });
        video.addEventListener('ended', function () {
          card.classList.remove('is-playing');
          videoPlaying = false;
          start();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
  function initCollectionProducts(root) {
    const getGrid = () => root.querySelector('[data-products-grid]');
    const getLiveRegion = () => root.querySelector('[data-results-count]');

    /* Column count switcher — custom listbox acting as a select */
    const colSwitch = root.querySelector('[data-column-switch]');
    const colTrigger = root.querySelector('[data-column-trigger]');
    const colList = root.querySelector('[data-column-list]');
    const colLabel = root.querySelector('[data-column-label]');
    const colOptions = colSwitch ? Array.from(colSwitch.querySelectorAll('.column-switch__option')) : [];
    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
    const getCols = () => (isMobile() ? [2, 1] : [4, 3, 2]);
    const visibleOptions = () => colOptions.filter((option) => option.offsetParent !== null);
    const STORE_KEY = 'plp-columns';
    let cols = parseInt(localStorage.getItem(STORE_KEY), 10);
    if (!getCols().includes(cols)) cols = isMobile() ? 2 : 4;

    const applyCols = () => {
      const grid = getGrid();
      if (grid) {
        grid.style.setProperty('--grid-cols', cols);
        grid.setAttribute('data-cols', cols);
      }
      /* Derive the label word from the server-rendered text so it stays localized */
      const word = (colLabel && colLabel.textContent || 'columns').replace(/^\s*\d+\s*/, '').trim() || 'columns';
      if (colLabel) colLabel.textContent = cols + ' ' + word;
      colOptions.forEach((option) => {
        const isSelected = parseInt(option.dataset.cols, 10) === cols;
        option.setAttribute('aria-selected', String(isSelected));
        option.tabIndex = isSelected ? 0 : -1;
      });
    };
    applyCols();

    const openColList = () => {
      if (!colList || !colTrigger) return;
      colList.hidden = false;
      colTrigger.setAttribute('aria-expanded', 'true');
      const options = visibleOptions();
      const selected = options.find((option) => option.getAttribute('aria-selected') === 'true');
      (selected || options[0]).focus();
    };
    const closeColList = (focusTrigger) => {
      if (!colList || !colTrigger) return;
      colList.hidden = true;
      colTrigger.setAttribute('aria-expanded', 'false');
      if (focusTrigger) colTrigger.focus();
    };
    const selectCols = (value) => {
      cols = value;
      localStorage.setItem(STORE_KEY, String(cols));
      applyCols();
    };

    if (colTrigger) {
      colTrigger.addEventListener('click', () => {
        if (colList.hidden) openColList();
        else closeColList(false);
      });
    }
    colOptions.forEach((option) => {
      option.addEventListener('click', () => {
        selectCols(parseInt(option.dataset.cols, 10));
        closeColList(true);
      });
      option.addEventListener('keydown', (e) => {
        const options = visibleOptions();
        const currentIndex = options.indexOf(option);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          options[(currentIndex + 1) % options.length].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          options[(currentIndex - 1 + options.length) % options.length].focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCols(parseInt(option.dataset.cols, 10));
          closeColList(true);
        } else if (e.key === 'Escape') {
          closeColList(true);
        } else if (e.key === 'Tab') {
          closeColList(false);
        }
      });
    });
    document.addEventListener('click', (e) => {
      if (colSwitch && !colList.hidden && !colSwitch.contains(e.target)) closeColList(false);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && colList && !colList.hidden) closeColList(true);
    });

    /* Filter panel toggle (inline on desktop, full-screen on mobile) */
    const panelWrap = root.querySelector('[data-filter-panel-wrap]');
    const toggleBtn = root.querySelector('[data-filter-toggle]');
    const panelBody = root.querySelector('[data-filter-panel]');

    const openPanel = () => {
      if (!panelWrap) return;
      panelWrap.classList.add('is-open');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
      if (panelBody) panelBody.hidden = false;
      if (isMobile()) document.body.style.overflow = 'hidden';
    };
    const closePanel = () => {
      if (!panelWrap) return;
      panelWrap.classList.remove('is-open');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      if (panelBody) panelBody.hidden = true;
      document.body.style.overflow = '';
    };

    if (toggleBtn) {
      toggleBtn.addEventListener('click', () => {
        if (panelWrap.classList.contains('is-open')) closePanel();
        else openPanel();
      });
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panelWrap && panelWrap.classList.contains('is-open')) closePanel();
    });

    /* Active filter count badge */
    const countEl = root.querySelector('[data-filter-count]');
    const updateFilterCount = () => {
      if (!countEl) return;
      const activeTags = root.querySelectorAll('.filter-chip:not(.filter-chip--clear)').length;
      countEl.textContent = activeTags > 0 ? String(activeTags) : '';
      countEl.hidden = activeTags === 0;
    };
    updateFilterCount();

    /* Price range dual slider — (re)bound after every AJAX swap since the sliders are replaced */
    const initPriceRanges = () => {
      root.querySelectorAll('[data-price-range]').forEach((range) => {
        const minInput = range.querySelector('[data-price-min]');
        const maxInput = range.querySelector('[data-price-max]');
        const fill = range.querySelector('[data-price-fill]');
        const display = range.querySelector('[data-price-display]');
        if (!minInput || !maxInput) return;

        const floor = Number(range.dataset.floor) || 0;
        const ceil = Number(range.dataset.ceil) || 100;
        const span = ceil - floor || 1;
        const fmt = (n) => '$' + Number(n).toLocaleString('es-CO');

        const paint = () => {
          let lo = Number(minInput.value);
          let hi = Number(maxInput.value);
          if (lo > hi) {
            const t = lo;
            lo = hi;
            hi = t;
          }
          if (fill) {
            fill.style.left = ((lo - floor) / span) * 100 + '%';
            fill.style.right = (100 - ((hi - floor) / span) * 100) + '%';
          }
          if (display) display.textContent = fmt(lo) + ' – ' + fmt(hi);
        };

        minInput.addEventListener('input', () => {
          if (Number(minInput.value) > Number(maxInput.value)) minInput.value = maxInput.value;
          paint();
        });
        maxInput.addEventListener('input', () => {
          if (Number(maxInput.value) < Number(minInput.value)) maxInput.value = minInput.value;
          paint();
        });

        const apply = () => {
          const params = new URLSearchParams(window.location.search);
          params.set(range.dataset.minParam, minInput.value);
          params.set(range.dataset.maxParam, maxInput.value);
          params.delete('page');
          updateCollection(window.location.pathname + '?' + params.toString());
        };
        minInput.addEventListener('change', apply);
        maxInput.addEventListener('change', apply);

        paint();
      });
    };

    /* Load more — (re)bound after every AJAX swap since the button node is replaced */
    const bindLoadMore = () => {
      const loadMoreBtn = root.querySelector('[data-load-more]');
      if (!loadMoreBtn) return;
      loadMoreBtn.addEventListener('click', async (event) => {
        event.preventDefault();
        if (loadMoreBtn.getAttribute('aria-disabled') === 'true') return;
        const url = loadMoreBtn.dataset.nextUrl;
        if (!url) return;
        const grid = getGrid();
        const liveRegion = getLiveRegion();
        const originalLabel = loadMoreBtn.textContent;
        loadMoreBtn.setAttribute('aria-disabled', 'true');
        loadMoreBtn.textContent = '...';
        try {
          const res = await fetch(url);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newCards = doc.querySelectorAll('[data-products-grid] > .product-card');
          newCards.forEach((card) => grid.appendChild(card));
          const nextBtn = doc.querySelector('[data-load-more]');
          if (nextBtn && nextBtn.dataset.nextUrl) {
            loadMoreBtn.dataset.nextUrl = nextBtn.dataset.nextUrl;
            loadMoreBtn.setAttribute('href', nextBtn.dataset.nextUrl);
            loadMoreBtn.textContent = originalLabel;
            loadMoreBtn.removeAttribute('aria-disabled');
          } else {
            loadMoreBtn.remove();
          }
          if (liveRegion) {
            liveRegion.textContent = grid.querySelectorAll('.product-card').length + ' / ' + liveRegion.textContent.trim();
          }
        } catch (err) {
          loadMoreBtn.textContent = originalLabel;
          loadMoreBtn.removeAttribute('aria-disabled');
        }
      });
    };

    /* AJAX filter/sort/price update — swaps the results grid and filter panel, no page reload */
    const updateCollection = async (url, { pushState = true } = {}) => {
      root.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const swapInner = (selector) => {
          const oldEl = root.querySelector(selector);
          const newEl = doc.querySelector(selector);
          if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
        };

        swapInner('[data-filter-panel]');
        swapInner('.filter-bar__active');
        swapInner('[data-products-results]');

        applyCols();
        updateFilterCount();
        initPriceRanges();
        bindLoadMore();

        if (pushState) history.pushState({ plpAjax: true }, '', url);
      } catch (err) {
        window.location.href = url;
      } finally {
        root.removeAttribute('aria-busy');
      }
    };

    /* Filter options + chips (add/remove/clear) → AJAX instead of navigation */
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-filter-close]')) {
        closePanel();
        return;
      }
      const link = e.target.closest('.filter-option, .filter-chip');
      if (link && link.getAttribute('aria-disabled') !== 'true') {
        e.preventDefault();
        updateCollection(link.href);
      }
    });

    /* Sort — custom listbox acting as a select → AJAX instead of full reload */
    const sortSwitch = root.querySelector('[data-sort-switch]');
    const sortTrigger = root.querySelector('[data-sort-trigger]');
    const sortList = root.querySelector('[data-sort-list]');
    const sortOptions = sortSwitch ? Array.from(sortSwitch.querySelectorAll('.sort-control__option')) : [];

    const openSortList = () => {
      if (!sortList || !sortTrigger) return;
      sortList.hidden = false;
      sortTrigger.setAttribute('aria-expanded', 'true');
      const selected = sortOptions.find((option) => option.getAttribute('aria-selected') === 'true');
      (selected || sortOptions[0]).focus();
    };
    const closeSortList = (focusTrigger) => {
      if (!sortList || !sortTrigger) return;
      sortList.hidden = true;
      sortTrigger.setAttribute('aria-expanded', 'false');
      if (focusTrigger) sortTrigger.focus();
    };
    const selectSort = (option) => {
      sortOptions.forEach((opt) => opt.setAttribute('aria-selected', String(opt === option)));
      const label = root.querySelector('[data-sort-label]');
      if (label) label.textContent = option.textContent.trim();
      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', option.dataset.value);
      params.delete('page');
      updateCollection(window.location.pathname + '?' + params.toString());
    };

    if (sortTrigger) {
      sortTrigger.addEventListener('click', () => {
        if (sortList.hidden) openSortList();
        else closeSortList(false);
      });
    }
    sortOptions.forEach((option) => {
      option.addEventListener('click', () => {
        selectSort(option);
        closeSortList(true);
      });
      option.addEventListener('keydown', (e) => {
        const currentIndex = sortOptions.indexOf(option);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          sortOptions[(currentIndex + 1) % sortOptions.length].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          sortOptions[(currentIndex - 1 + sortOptions.length) % sortOptions.length].focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectSort(option);
          closeSortList(true);
        } else if (e.key === 'Escape') {
          closeSortList(true);
        } else if (e.key === 'Tab') {
          closeSortList(false);
        }
      });
    });
    document.addEventListener('click', (e) => {
      if (sortSwitch && sortList && !sortList.hidden && !sortSwitch.contains(e.target)) closeSortList(false);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sortList && !sortList.hidden) closeSortList(true);
    });

    /* Back/forward navigation between AJAX-applied filter states */
    window.addEventListener('popstate', () => {
      updateCollection(window.location.href, { pushState: false });
    });

    initPriceRanges();
    bindLoadMore();
  }

  document.querySelectorAll('[data-collection-products]').forEach(initCollectionProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distributor-signup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.distributor-signup__form').forEach((form) => {
    form.addEventListener('submit', () => {
      const btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.dataset.label = btn.textContent;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-section').forEach((section) => {
    const fullHeight = (content) => {
      const body = content.querySelector('.accordion-body');
      return (body || content).getBoundingClientRect().height;
    };

    const collapse = (item) => {
      const content = item.querySelector('.accordion-content');
      const trigger = item.querySelector('.accordion-trigger');
      if (!content) return;

      content.style.height = content.getBoundingClientRect().height + 'px';
      item.classList.remove('open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');

      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
    };

    const expand = (item) => {
      const content = item.querySelector('.accordion-content');
      const trigger = item.querySelector('.accordion-trigger');
      if (!content) return;

      item.classList.add('open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');

      content.style.height = fullHeight(content) + 'px';

      const duration = parseFloat(getComputedStyle(content).transitionDuration) || 0;
      if (duration === 0) {
        content.style.height = '';
        return;
      }

      const done = (event) => {
        if (event.propertyName !== 'height') return;
        content.style.height = '';
        content.removeEventListener('transitionend', done);
      };
      content.addEventListener('transitionend', done);
    };

    section.querySelectorAll('.accordion-trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.accordion-item');
        const isOpen = item.classList.contains('open');

        section.querySelectorAll('.accordion-item.open').forEach(collapse);

        if (!isOpen) expand(item);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-kaba-makeup"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    const burger = header.querySelector('[data-header-burger]');
    const drawer = document.querySelector('[data-header-drawer]');
    const overlay = document.querySelector('[data-header-overlay]');
    const closeBtn = drawer ? drawer.querySelector('[data-header-close]') : null;
    const searchToggle = header.querySelector('[data-search-toggle]');
    const search = header.querySelector('.site-header__search');

    function openDrawer() {
      if (!drawer || !overlay) return;
      overlay.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(() => {
        overlay.hidden = true;
      }, 250);
    }

    if (burger) burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    if (searchToggle && search) {
      searchToggle.addEventListener('click', () => {
        const open = search.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          const input = search.querySelector('input');
          if (input) input.focus();
        }
      });
    }

    const predictiveSearch = header.querySelector('[data-predictive-search]');
    const predictiveInput = header.querySelector('[data-predictive-search-input]');
    const predictiveResults = header.querySelector('[data-predictive-search-results]');
    const predictiveStatus = header.querySelector('[data-predictive-search-status]');

    if (predictiveSearch && predictiveInput && predictiveResults) {
      let debounceId;
      let activeController;
      const suggestionsMarkup = predictiveResults.innerHTML;

      function showSuggestions() {
        if (!suggestionsMarkup) return;
        predictiveResults.innerHTML = suggestionsMarkup;
        predictiveResults.hidden = false;
        predictiveInput.setAttribute('aria-expanded', 'true');
      }

      function closePredictiveResults() {
        predictiveResults.hidden = true;
        predictiveResults.innerHTML = '';
        predictiveInput.setAttribute('aria-expanded', 'false');
      }

      function fetchPredictiveResults(term) {
        if (activeController) activeController.abort();
        activeController = new AbortController();

        const baseUrl = predictiveInput.dataset.predictiveSearchUrl;
        const url =
          baseUrl +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product,collection' +
          '&resources[limit]=6' +
          '&resources[limit_scope]=each' +
          '&section_id=predictive-search';

        fetch(url, { signal: activeController.signal })
          .then((response) => response.text())
          .then((html) => {
            predictiveResults.innerHTML = html;
            predictiveResults.hidden = false;
            predictiveInput.setAttribute('aria-expanded', 'true');
            if (predictiveStatus) {
              predictiveStatus.textContent = predictiveInput.dataset.predictiveSearchStatusText;
            }
          })
          .catch((error) => {
            if (error.name !== 'AbortError') closePredictiveResults();
          });
      }

      predictiveInput.addEventListener('input', () => {
        const term = predictiveInput.value.trim();
        clearTimeout(debounceId);
        if (term.length === 0) {
          showSuggestions();
          return;
        }
        if (term.length < 2) {
          closePredictiveResults();
          return;
        }
        debounceId = setTimeout(() => fetchPredictiveResults(term), 300);
      });

      const searchDrawerQuery = window.matchMedia('(max-width: 767px)');
      const searchClose = predictiveSearch.querySelector('[data-search-close]');
      let searchDrawerTimeout;

      function openSearchDrawer() {
        if (!searchDrawerQuery.matches || predictiveSearch.classList.contains('is-drawer-open')) return;
        clearTimeout(searchDrawerTimeout);
        predictiveSearch.classList.remove('is-drawer-closing');
        predictiveSearch.classList.add('is-drawer-open');
        document.body.style.overflow = 'hidden';
      }

      function closeSearchDrawer() {
        if (!predictiveSearch.classList.contains('is-drawer-open')) return;
        closePredictiveResults();
        predictiveInput.blur();
        predictiveSearch.classList.add('is-drawer-closing');
        document.body.style.overflow = '';
        searchDrawerTimeout = setTimeout(() => {
          predictiveSearch.classList.remove('is-drawer-open', 'is-drawer-closing');
        }, 250);
      }

      if (searchClose) searchClose.addEventListener('click', closeSearchDrawer);
      searchDrawerQuery.addEventListener('change', (event) => {
        if (!event.matches) closeSearchDrawer();
      });

      predictiveInput.addEventListener('focus', () => {
        openSearchDrawer();
        if (predictiveInput.value.trim().length === 0) showSuggestions();
      });

      predictiveInput.addEventListener('click', () => {
        if (predictiveInput.value.trim().length === 0) showSuggestions();
      });

      predictiveInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closePredictiveResults();
          closeSearchDrawer();
          predictiveInput.blur();
        }
      });

      document.addEventListener('click', (event) => {
        if (!predictiveSearch.contains(event.target)) closePredictiveResults();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePredictiveResults();
      });
    }

    if (drawer) {
      drawer.querySelectorAll('[data-drawer-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const panel = btn.nextElementSibling;
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (panel) panel.hidden = isOpen;
        });
      });
    }

    const promoGroups = Array.from(header.querySelectorAll('[data-site-header-promo]')).map((el) =>
      el.querySelectorAll('.site-header__promo-message')
    );
    const promoCount = promoGroups.length ? promoGroups[0].length : 0;
    if (promoCount > 1) {
      let promoIndex = 0;
      setInterval(() => {
        promoIndex = (promoIndex + 1) % promoCount;
        promoGroups.forEach((messages) => {
          messages.forEach((message, i) => message.classList.toggle('is-active', i === promoIndex));
        });
      }, 5000);
    }

    const brandNav = header.querySelector('[data-brand-nav]');
    if (brandNav) {
      const brandCookieName = 'dluchi_active_brand';
      const brandLinks = Array.from(brandNav.querySelectorAll('[data-brand-handle]'));

      function getBrandCookie() {
        const match = document.cookie.match('(?:^|; )' + brandCookieName + '=([^;]*)');
        return match ? decodeURIComponent(match[1]) : null;
      }

      function setBrandCookie(handle) {
        if (!handle) return;
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie =
          brandCookieName + '=' + encodeURIComponent(handle) + '; expires=' + expires + '; path=/; SameSite=Lax';
      }

      if (brandNav.dataset.urlMatch === 'true') {
        const activeLink = brandLinks.find((link) => link.classList.contains('is-active'));
        if (activeLink) setBrandCookie(activeLink.dataset.brandHandle);
      } else {
        const savedHandle = getBrandCookie();
        if (savedHandle) {
          brandLinks.forEach((link) => {
            link.classList.toggle('is-active', link.dataset.brandHandle === savedHandle);
          });
        }
      }

      brandLinks.forEach((link) => {
        link.addEventListener('click', () => setBrandCookie(link.dataset.brandHandle));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-kaba"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    const burger = header.querySelector('[data-header-burger]');
    const drawer = document.querySelector('[data-header-drawer]');
    const overlay = document.querySelector('[data-header-overlay]');
    const closeBtn = drawer ? drawer.querySelector('[data-header-close]') : null;
    const searchToggle = header.querySelector('[data-search-toggle]');
    const search = header.querySelector('.site-header__search');

    function openDrawer() {
      if (!drawer || !overlay) return;
      overlay.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(() => {
        overlay.hidden = true;
      }, 250);
    }

    if (burger) burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    if (searchToggle && search) {
      searchToggle.addEventListener('click', () => {
        const open = search.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          const input = search.querySelector('input');
          if (input) input.focus();
        }
      });
    }

    const predictiveSearch = header.querySelector('[data-predictive-search]');
    const predictiveInput = header.querySelector('[data-predictive-search-input]');
    const predictiveResults = header.querySelector('[data-predictive-search-results]');
    const predictiveStatus = header.querySelector('[data-predictive-search-status]');

    if (predictiveSearch && predictiveInput && predictiveResults) {
      let debounceId;
      let activeController;
      const suggestionsMarkup = predictiveResults.innerHTML;

      function showSuggestions() {
        if (!suggestionsMarkup) return;
        predictiveResults.innerHTML = suggestionsMarkup;
        predictiveResults.hidden = false;
        predictiveInput.setAttribute('aria-expanded', 'true');
      }

      function closePredictiveResults() {
        predictiveResults.hidden = true;
        predictiveResults.innerHTML = '';
        predictiveInput.setAttribute('aria-expanded', 'false');
      }

      function fetchPredictiveResults(term) {
        if (activeController) activeController.abort();
        activeController = new AbortController();

        const baseUrl = predictiveInput.dataset.predictiveSearchUrl;
        const url =
          baseUrl +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product,collection' +
          '&resources[limit]=6' +
          '&resources[limit_scope]=each' +
          '&section_id=predictive-search';

        fetch(url, { signal: activeController.signal })
          .then((response) => response.text())
          .then((html) => {
            predictiveResults.innerHTML = html;
            predictiveResults.hidden = false;
            predictiveInput.setAttribute('aria-expanded', 'true');
            if (predictiveStatus) {
              predictiveStatus.textContent = predictiveInput.dataset.predictiveSearchStatusText;
            }
          })
          .catch((error) => {
            if (error.name !== 'AbortError') closePredictiveResults();
          });
      }

      predictiveInput.addEventListener('input', () => {
        const term = predictiveInput.value.trim();
        clearTimeout(debounceId);
        if (term.length === 0) {
          showSuggestions();
          return;
        }
        if (term.length < 2) {
          closePredictiveResults();
          return;
        }
        debounceId = setTimeout(() => fetchPredictiveResults(term), 300);
      });

      const searchDrawerQuery = window.matchMedia('(max-width: 767px)');
      const searchClose = predictiveSearch.querySelector('[data-search-close]');
      let searchDrawerTimeout;

      function openSearchDrawer() {
        if (!searchDrawerQuery.matches || predictiveSearch.classList.contains('is-drawer-open')) return;
        clearTimeout(searchDrawerTimeout);
        predictiveSearch.classList.remove('is-drawer-closing');
        predictiveSearch.classList.add('is-drawer-open');
        document.body.style.overflow = 'hidden';
      }

      function closeSearchDrawer() {
        if (!predictiveSearch.classList.contains('is-drawer-open')) return;
        closePredictiveResults();
        predictiveInput.blur();
        predictiveSearch.classList.add('is-drawer-closing');
        document.body.style.overflow = '';
        searchDrawerTimeout = setTimeout(() => {
          predictiveSearch.classList.remove('is-drawer-open', 'is-drawer-closing');
        }, 250);
      }

      if (searchClose) searchClose.addEventListener('click', closeSearchDrawer);
      searchDrawerQuery.addEventListener('change', (event) => {
        if (!event.matches) closeSearchDrawer();
      });

      predictiveInput.addEventListener('focus', () => {
        openSearchDrawer();
        if (predictiveInput.value.trim().length === 0) showSuggestions();
      });

      predictiveInput.addEventListener('click', () => {
        if (predictiveInput.value.trim().length === 0) showSuggestions();
      });

      predictiveInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closePredictiveResults();
          closeSearchDrawer();
          predictiveInput.blur();
        }
      });

      document.addEventListener('click', (event) => {
        if (!predictiveSearch.contains(event.target)) closePredictiveResults();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePredictiveResults();
      });
    }

    if (drawer) {
      drawer.querySelectorAll('[data-drawer-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const panel = btn.nextElementSibling;
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (panel) panel.hidden = isOpen;
        });
      });
    }

    const promoGroups = Array.from(header.querySelectorAll('[data-site-header-promo]')).map((el) =>
      el.querySelectorAll('.site-header__promo-message')
    );
    const promoCount = promoGroups.length ? promoGroups[0].length : 0;
    if (promoCount > 1) {
      let promoIndex = 0;
      setInterval(() => {
        promoIndex = (promoIndex + 1) % promoCount;
        promoGroups.forEach((messages) => {
          messages.forEach((message, i) => message.classList.toggle('is-active', i === promoIndex));
        });
      }, 5000);
    }

    const brandNav = header.querySelector('[data-brand-nav]');
    if (brandNav) {
      const brandCookieName = 'dluchi_active_brand';
      const brandLinks = Array.from(brandNav.querySelectorAll('[data-brand-handle]'));

      function getBrandCookie() {
        const match = document.cookie.match('(?:^|; )' + brandCookieName + '=([^;]*)');
        return match ? decodeURIComponent(match[1]) : null;
      }

      function setBrandCookie(handle) {
        if (!handle) return;
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie =
          brandCookieName + '=' + encodeURIComponent(handle) + '; expires=' + expires + '; path=/; SameSite=Lax';
      }

      if (brandNav.dataset.urlMatch === 'true') {
        const activeLink = brandLinks.find((link) => link.classList.contains('is-active'));
        if (activeLink) setBrandCookie(activeLink.dataset.brandHandle);
      } else {
        const savedHandle = getBrandCookie();
        if (savedHandle) {
          brandLinks.forEach((link) => {
            link.classList.toggle('is-active', link.dataset.brandHandle === savedHandle);
          });
        }
      }

      brandLinks.forEach((link) => {
        link.addEventListener('click', () => setBrandCookie(link.dataset.brandHandle));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-la-receta"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    const burger = header.querySelector('[data-header-burger]');
    const drawer = document.querySelector('[data-header-drawer]');
    const overlay = document.querySelector('[data-header-overlay]');
    const closeBtn = drawer ? drawer.querySelector('[data-header-close]') : null;
    const searchToggle = header.querySelector('[data-search-toggle]');
    const search = header.querySelector('.site-header__search');

    function openDrawer() {
      if (!drawer || !overlay) return;
      overlay.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(() => {
        overlay.hidden = true;
      }, 250);
    }

    if (burger) burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    if (searchToggle && search) {
      searchToggle.addEventListener('click', () => {
        const open = search.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          const input = search.querySelector('input');
          if (input) input.focus();
        }
      });
    }

    const predictiveSearch = header.querySelector('[data-predictive-search]');
    const predictiveInput = header.querySelector('[data-predictive-search-input]');
    const predictiveResults = header.querySelector('[data-predictive-search-results]');
    const predictiveStatus = header.querySelector('[data-predictive-search-status]');

    if (predictiveSearch && predictiveInput && predictiveResults) {
      let debounceId;
      let activeController;
      const suggestionsMarkup = predictiveResults.innerHTML;

      function showSuggestions() {
        if (!suggestionsMarkup) return;
        predictiveResults.innerHTML = suggestionsMarkup;
        predictiveResults.hidden = false;
        predictiveInput.setAttribute('aria-expanded', 'true');
      }

      function closePredictiveResults() {
        predictiveResults.hidden = true;
        predictiveResults.innerHTML = '';
        predictiveInput.setAttribute('aria-expanded', 'false');
      }

      function fetchPredictiveResults(term) {
        if (activeController) activeController.abort();
        activeController = new AbortController();

        const baseUrl = predictiveInput.dataset.predictiveSearchUrl;
        const url =
          baseUrl +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product,collection' +
          '&resources[limit]=6' +
          '&resources[limit_scope]=each' +
          '&section_id=predictive-search';

        fetch(url, { signal: activeController.signal })
          .then((response) => response.text())
          .then((html) => {
            predictiveResults.innerHTML = html;
            predictiveResults.hidden = false;
            predictiveInput.setAttribute('aria-expanded', 'true');
            if (predictiveStatus) {
              predictiveStatus.textContent = predictiveInput.dataset.predictiveSearchStatusText;
            }
          })
          .catch((error) => {
            if (error.name !== 'AbortError') closePredictiveResults();
          });
      }

      predictiveInput.addEventListener('input', () => {
        const term = predictiveInput.value.trim();
        clearTimeout(debounceId);
        if (term.length === 0) {
          showSuggestions();
          return;
        }
        if (term.length < 2) {
          closePredictiveResults();
          return;
        }
        debounceId = setTimeout(() => fetchPredictiveResults(term), 300);
      });

      const searchDrawerQuery = window.matchMedia('(max-width: 767px)');
      const searchClose = predictiveSearch.querySelector('[data-search-close]');
      let searchDrawerTimeout;

      function openSearchDrawer() {
        if (!searchDrawerQuery.matches || predictiveSearch.classList.contains('is-drawer-open')) return;
        clearTimeout(searchDrawerTimeout);
        predictiveSearch.classList.remove('is-drawer-closing');
        predictiveSearch.classList.add('is-drawer-open');
        document.body.style.overflow = 'hidden';
      }

      function closeSearchDrawer() {
        if (!predictiveSearch.classList.contains('is-drawer-open')) return;
        closePredictiveResults();
        predictiveInput.blur();
        predictiveSearch.classList.add('is-drawer-closing');
        document.body.style.overflow = '';
        searchDrawerTimeout = setTimeout(() => {
          predictiveSearch.classList.remove('is-drawer-open', 'is-drawer-closing');
        }, 250);
      }

      if (searchClose) searchClose.addEventListener('click', closeSearchDrawer);
      searchDrawerQuery.addEventListener('change', (event) => {
        if (!event.matches) closeSearchDrawer();
      });

      predictiveInput.addEventListener('focus', () => {
        openSearchDrawer();
        if (predictiveInput.value.trim().length === 0) showSuggestions();
      });

      predictiveInput.addEventListener('click', () => {
        if (predictiveInput.value.trim().length === 0) showSuggestions();
      });

      predictiveInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closePredictiveResults();
          closeSearchDrawer();
          predictiveInput.blur();
        }
      });

      document.addEventListener('click', (event) => {
        if (!predictiveSearch.contains(event.target)) closePredictiveResults();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePredictiveResults();
      });
    }

    if (drawer) {
      drawer.querySelectorAll('[data-drawer-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const panel = btn.nextElementSibling;
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (panel) panel.hidden = isOpen;
        });
      });
    }

    const promoGroups = Array.from(header.querySelectorAll('[data-site-header-promo]')).map((el) =>
      el.querySelectorAll('.site-header__promo-message')
    );
    const promoCount = promoGroups.length ? promoGroups[0].length : 0;
    if (promoCount > 1) {
      let promoIndex = 0;
      setInterval(() => {
        promoIndex = (promoIndex + 1) % promoCount;
        promoGroups.forEach((messages) => {
          messages.forEach((message, i) => message.classList.toggle('is-active', i === promoIndex));
        });
      }, 5000);
    }

    const brandNav = header.querySelector('[data-brand-nav]');
    if (brandNav) {
      const brandCookieName = 'dluchi_active_brand';
      const brandLinks = Array.from(brandNav.querySelectorAll('[data-brand-handle]'));

      function getBrandCookie() {
        const match = document.cookie.match('(?:^|; )' + brandCookieName + '=([^;]*)');
        return match ? decodeURIComponent(match[1]) : null;
      }

      function setBrandCookie(handle) {
        if (!handle) return;
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie =
          brandCookieName + '=' + encodeURIComponent(handle) + '; expires=' + expires + '; path=/; SameSite=Lax';
      }

      if (brandNav.dataset.urlMatch === 'true') {
        const activeLink = brandLinks.find((link) => link.classList.contains('is-active'));
        if (activeLink) setBrandCookie(activeLink.dataset.brandHandle);
      } else {
        const savedHandle = getBrandCookie();
        if (savedHandle) {
          brandLinks.forEach((link) => {
            link.classList.toggle('is-active', link.dataset.brandHandle === savedHandle);
          });
        }
      }

      brandLinks.forEach((link) => {
        link.addEventListener('click', () => setBrandCookie(link.dataset.brandHandle));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-omg"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    const burger = header.querySelector('[data-header-burger]');
    const drawer = document.querySelector('[data-header-drawer]');
    const overlay = document.querySelector('[data-header-overlay]');
    const closeBtn = drawer ? drawer.querySelector('[data-header-close]') : null;
    const searchToggle = header.querySelector('[data-search-toggle]');
    const search = header.querySelector('.site-header__search');

    function openDrawer() {
      if (!drawer || !overlay) return;
      overlay.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(() => {
        overlay.hidden = true;
      }, 250);
    }

    if (burger) burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    if (searchToggle && search) {
      searchToggle.addEventListener('click', () => {
        const open = search.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          const input = search.querySelector('input');
          if (input) input.focus();
        }
      });
    }

    const predictiveSearch = header.querySelector('[data-predictive-search]');
    const predictiveInput = header.querySelector('[data-predictive-search-input]');
    const predictiveResults = header.querySelector('[data-predictive-search-results]');
    const predictiveStatus = header.querySelector('[data-predictive-search-status]');

    if (predictiveSearch && predictiveInput && predictiveResults) {
      let debounceId;
      let activeController;
      const suggestionsMarkup = predictiveResults.innerHTML;

      function showSuggestions() {
        if (!suggestionsMarkup) return;
        predictiveResults.innerHTML = suggestionsMarkup;
        predictiveResults.hidden = false;
        predictiveInput.setAttribute('aria-expanded', 'true');
      }

      function closePredictiveResults() {
        predictiveResults.hidden = true;
        predictiveResults.innerHTML = '';
        predictiveInput.setAttribute('aria-expanded', 'false');
      }

      function fetchPredictiveResults(term) {
        if (activeController) activeController.abort();
        activeController = new AbortController();

        const baseUrl = predictiveInput.dataset.predictiveSearchUrl;
        const url =
          baseUrl +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product,collection' +
          '&resources[limit]=6' +
          '&resources[limit_scope]=each' +
          '&section_id=predictive-search';

        fetch(url, { signal: activeController.signal })
          .then((response) => response.text())
          .then((html) => {
            predictiveResults.innerHTML = html;
            predictiveResults.hidden = false;
            predictiveInput.setAttribute('aria-expanded', 'true');
            if (predictiveStatus) {
              predictiveStatus.textContent = predictiveInput.dataset.predictiveSearchStatusText;
            }
          })
          .catch((error) => {
            if (error.name !== 'AbortError') closePredictiveResults();
          });
      }

      predictiveInput.addEventListener('input', () => {
        const term = predictiveInput.value.trim();
        clearTimeout(debounceId);
        if (term.length === 0) {
          showSuggestions();
          return;
        }
        if (term.length < 2) {
          closePredictiveResults();
          return;
        }
        debounceId = setTimeout(() => fetchPredictiveResults(term), 300);
      });

      const searchDrawerQuery = window.matchMedia('(max-width: 767px)');
      const searchClose = predictiveSearch.querySelector('[data-search-close]');
      let searchDrawerTimeout;

      function openSearchDrawer() {
        if (!searchDrawerQuery.matches || predictiveSearch.classList.contains('is-drawer-open')) return;
        clearTimeout(searchDrawerTimeout);
        predictiveSearch.classList.remove('is-drawer-closing');
        predictiveSearch.classList.add('is-drawer-open');
        document.body.style.overflow = 'hidden';
      }

      function closeSearchDrawer() {
        if (!predictiveSearch.classList.contains('is-drawer-open')) return;
        closePredictiveResults();
        predictiveInput.blur();
        predictiveSearch.classList.add('is-drawer-closing');
        document.body.style.overflow = '';
        searchDrawerTimeout = setTimeout(() => {
          predictiveSearch.classList.remove('is-drawer-open', 'is-drawer-closing');
        }, 250);
      }

      if (searchClose) searchClose.addEventListener('click', closeSearchDrawer);
      searchDrawerQuery.addEventListener('change', (event) => {
        if (!event.matches) closeSearchDrawer();
      });

      predictiveInput.addEventListener('focus', () => {
        openSearchDrawer();
        if (predictiveInput.value.trim().length === 0) showSuggestions();
      });

      predictiveInput.addEventListener('click', () => {
        if (predictiveInput.value.trim().length === 0) showSuggestions();
      });

      predictiveInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closePredictiveResults();
          closeSearchDrawer();
          predictiveInput.blur();
        }
      });

      document.addEventListener('click', (event) => {
        if (!predictiveSearch.contains(event.target)) closePredictiveResults();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePredictiveResults();
      });
    }

    if (drawer) {
      drawer.querySelectorAll('[data-drawer-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const panel = btn.nextElementSibling;
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (panel) panel.hidden = isOpen;
        });
      });
    }

    const promoGroups = Array.from(header.querySelectorAll('[data-site-header-promo]')).map((el) =>
      el.querySelectorAll('.site-header__promo-message')
    );
    const promoCount = promoGroups.length ? promoGroups[0].length : 0;
    if (promoCount > 1) {
      let promoIndex = 0;
      setInterval(() => {
        promoIndex = (promoIndex + 1) % promoCount;
        promoGroups.forEach((messages) => {
          messages.forEach((message, i) => message.classList.toggle('is-active', i === promoIndex));
        });
      }, 5000);
    }

    const brandNav = header.querySelector('[data-brand-nav]');
    if (brandNav) {
      const brandCookieName = 'dluchi_active_brand';
      const brandLinks = Array.from(brandNav.querySelectorAll('[data-brand-handle]'));

      function getBrandCookie() {
        const match = document.cookie.match('(?:^|; )' + brandCookieName + '=([^;]*)');
        return match ? decodeURIComponent(match[1]) : null;
      }

      function setBrandCookie(handle) {
        if (!handle) return;
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie =
          brandCookieName + '=' + encodeURIComponent(handle) + '; expires=' + expires + '; path=/; SameSite=Lax';
      }

      if (brandNav.dataset.urlMatch === 'true') {
        const activeLink = brandLinks.find((link) => link.classList.contains('is-active'));
        if (activeLink) setBrandCookie(activeLink.dataset.brandHandle);
      } else {
        const savedHandle = getBrandCookie();
        if (savedHandle) {
          brandLinks.forEach((link) => {
            link.classList.toggle('is-active', link.dataset.brandHandle === savedHandle);
          });
        }
      }

      brandLinks.forEach((link) => {
        link.addEventListener('click', () => setBrandCookie(link.dataset.brandHandle));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    const burger = header.querySelector('[data-header-burger]');
    const drawer = document.querySelector('[data-header-drawer]');
    const overlay = document.querySelector('[data-header-overlay]');
    const closeBtn = drawer ? drawer.querySelector('[data-header-close]') : null;
    const searchToggle = header.querySelector('[data-search-toggle]');
    const search = header.querySelector('.site-header__search');

    function openDrawer() {
      if (!drawer || !overlay) return;
      overlay.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(() => {
        overlay.hidden = true;
      }, 250);
    }

    if (burger) burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    if (searchToggle && search) {
      searchToggle.addEventListener('click', () => {
        const open = search.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          const input = search.querySelector('input');
          if (input) input.focus();
        }
      });
    }

    const predictiveSearch = header.querySelector('[data-predictive-search]');
    const predictiveInput = header.querySelector('[data-predictive-search-input]');
    const predictiveResults = header.querySelector('[data-predictive-search-results]');
    const predictiveStatus = header.querySelector('[data-predictive-search-status]');

    if (predictiveSearch && predictiveInput && predictiveResults) {
      let debounceId;
      let activeController;
      const suggestionsMarkup = predictiveResults.innerHTML;

      function showSuggestions() {
        if (!suggestionsMarkup) return;
        predictiveResults.innerHTML = suggestionsMarkup;
        predictiveResults.hidden = false;
        predictiveInput.setAttribute('aria-expanded', 'true');
      }

      function closePredictiveResults() {
        predictiveResults.hidden = true;
        predictiveResults.innerHTML = '';
        predictiveInput.setAttribute('aria-expanded', 'false');
      }

      function fetchPredictiveResults(term) {
        if (activeController) activeController.abort();
        activeController = new AbortController();

        const baseUrl = predictiveInput.dataset.predictiveSearchUrl;
        const url =
          baseUrl +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product,collection' +
          '&resources[limit]=6' +
          '&resources[limit_scope]=each' +
          '&section_id=predictive-search';

        fetch(url, { signal: activeController.signal })
          .then((response) => response.text())
          .then((html) => {
            predictiveResults.innerHTML = html;
            predictiveResults.hidden = false;
            predictiveInput.setAttribute('aria-expanded', 'true');
            if (predictiveStatus) {
              predictiveStatus.textContent = predictiveInput.dataset.predictiveSearchStatusText;
            }
          })
          .catch((error) => {
            if (error.name !== 'AbortError') closePredictiveResults();
          });
      }

      predictiveInput.addEventListener('input', () => {
        const term = predictiveInput.value.trim();
        clearTimeout(debounceId);
        if (term.length === 0) {
          showSuggestions();
          return;
        }
        if (term.length < 2) {
          closePredictiveResults();
          return;
        }
        debounceId = setTimeout(() => fetchPredictiveResults(term), 300);
      });

      const searchDrawerQuery = window.matchMedia('(max-width: 767px)');
      const searchClose = predictiveSearch.querySelector('[data-search-close]');
      let searchDrawerTimeout;

      function openSearchDrawer() {
        if (!searchDrawerQuery.matches || predictiveSearch.classList.contains('is-drawer-open')) return;
        clearTimeout(searchDrawerTimeout);
        predictiveSearch.classList.remove('is-drawer-closing');
        predictiveSearch.classList.add('is-drawer-open');
        document.body.style.overflow = 'hidden';
      }

      function closeSearchDrawer() {
        if (!predictiveSearch.classList.contains('is-drawer-open')) return;
        closePredictiveResults();
        predictiveInput.blur();
        predictiveSearch.classList.add('is-drawer-closing');
        document.body.style.overflow = '';
        searchDrawerTimeout = setTimeout(() => {
          predictiveSearch.classList.remove('is-drawer-open', 'is-drawer-closing');
        }, 250);
      }

      if (searchClose) searchClose.addEventListener('click', closeSearchDrawer);
      searchDrawerQuery.addEventListener('change', (event) => {
        if (!event.matches) closeSearchDrawer();
      });

      predictiveInput.addEventListener('focus', () => {
        openSearchDrawer();
        if (predictiveInput.value.trim().length === 0) showSuggestions();
      });

      predictiveInput.addEventListener('click', () => {
        if (predictiveInput.value.trim().length === 0) showSuggestions();
      });

      predictiveInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closePredictiveResults();
          closeSearchDrawer();
          predictiveInput.blur();
        }
      });

      document.addEventListener('click', (event) => {
        if (!predictiveSearch.contains(event.target)) closePredictiveResults();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePredictiveResults();
      });
    }

    if (drawer) {
      // Subgroups flagged by the `drawer_auto_open_groups` setting go back to expanded
      // every time their parent category is unfolded.
      function restoreAutoOpen(panel) {
        panel.querySelectorAll('[data-drawer-auto-open]').forEach((autoBtn) => {
          const autoPanel = autoBtn.nextElementSibling;
          autoBtn.setAttribute('aria-expanded', 'true');
          if (autoPanel) autoPanel.hidden = false;
        });
      }

      drawer.querySelectorAll('[data-drawer-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const panel = btn.nextElementSibling;
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (panel) panel.hidden = isOpen;
          if (panel && !isOpen && btn.classList.contains('site-header__drawer-toggle')) {
            restoreAutoOpen(panel);
          }
        });
      });
    }

    const promoGroups = Array.from(header.querySelectorAll('[data-site-header-promo]')).map((el) =>
      el.querySelectorAll('.site-header__promo-message')
    );
    const promoCount = promoGroups.length ? promoGroups[0].length : 0;
    if (promoCount > 1) {
      let promoIndex = 0;
      setInterval(() => {
        promoIndex = (promoIndex + 1) % promoCount;
        promoGroups.forEach((messages) => {
          messages.forEach((message, i) => message.classList.toggle('is-active', i === promoIndex));
        });
      }, 5000);
    }

    const brandNav = header.querySelector('[data-brand-nav]');
    if (brandNav) {
      const brandCookieName = 'dluchi_active_brand';
      const brandLinks = Array.from(brandNav.querySelectorAll('[data-brand-handle]'));

      function getBrandCookie() {
        const match = document.cookie.match('(?:^|; )' + brandCookieName + '=([^;]*)');
        return match ? decodeURIComponent(match[1]) : null;
      }

      function setBrandCookie(handle) {
        if (!handle) return;
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie =
          brandCookieName + '=' + encodeURIComponent(handle) + '; expires=' + expires + '; path=/; SameSite=Lax';
      }

      if (brandNav.dataset.urlMatch === 'true') {
        const activeLink = brandLinks.find((link) => link.classList.contains('is-active'));
        if (activeLink) setBrandCookie(activeLink.dataset.brandHandle);
      } else {
        const savedHandle = getBrandCookie();
        if (savedHandle) {
          brandLinks.forEach((link) => {
            link.classList.toggle('is-active', link.dataset.brandHandle === savedHandle);
          });
        }
      }

      brandLinks.forEach((link) => {
        link.addEventListener('click', () => setBrandCookie(link.dataset.brandHandle));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-best-sellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-best-sellers]').forEach((section) => {
    const el = section.querySelector('.home-best-sellers__swiper');
    if (!el || typeof Swiper === 'undefined') return;

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      grabCursor: true,
      loop: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      a11y: { enabled: true },
      navigation: {
        nextEl: section.querySelector('.home-best-sellers__arrow--next'),
        prevEl: section.querySelector('.home-best-sellers__arrow--prev'),
      },
      pagination: {
        el: section.querySelector('.home-best-sellers__pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
          pagination: { enabled: false },
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-categories"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-categories]').forEach((section) => {
    const el = section.querySelector('.home-categories__swiper');
    if (!el || typeof Swiper === 'undefined') return;
    let instance = null;

    const sync = () => {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      if (isMobile && !instance) {
        instance = new Swiper(el, {
          slidesPerView: 'auto',
          spaceBetween: 16,
          grabCursor: true,
          loop: true,
          a11y: { enabled: true },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: section.querySelector('.home-categories__pagination'),
            clickable: true,
          },
        });
      } else if (!isMobile && instance) {
        instance.destroy(true, true);
        instance = null;
      }
    };

    sync();
    window.addEventListener('resize', sync);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-collection-slider]').forEach((section) => {
    const el = section.querySelector('.home-collection-slider__swiper');
    if (!el || typeof Swiper === 'undefined') return;

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      grabCursor: true,
      a11y: { enabled: true },
      navigation: {
        nextEl: section.querySelector('.home-collection-slider__arrow--next'),
        prevEl: section.querySelector('.home-collection-slider__arrow--prev')
      },
      pagination: {
        el: section.querySelector('.home-collection-slider__pagination'),
        clickable: true
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
          pagination: { enabled: false }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-filter-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-filter-slider]').forEach((section) => {
    const panels = section.querySelectorAll('.home-filter-slider__panel');
    const pills = section.querySelectorAll('.home-filter-slider__pill');
    const labelDropdown = section.querySelector('[data-filters-label]');
    const labelToggle = labelDropdown ? labelDropdown.querySelector('[data-filters-label-toggle]') : null;
    const labelMenu = labelDropdown ? labelDropdown.querySelector('[data-filters-label-menu]') : null;
    const labelOptions = labelDropdown ? labelDropdown.querySelectorAll('.home-filter-slider__filters-option') : [];
    const defaultPills = section.querySelector('[data-default-pills]');
    const pillsPrev = section.querySelector('[data-pills-prev]');
    const pillsNext = section.querySelector('[data-pills-next]');

    const updatePillsArrows = () => {
      if (!defaultPills || !pillsPrev || !pillsNext) return;
      const maxScroll = defaultPills.scrollWidth - defaultPills.clientWidth;
      pillsPrev.disabled = defaultPills.scrollLeft <= 0;
      pillsNext.disabled = defaultPills.scrollLeft >= maxScroll - 1;
    };

    if (defaultPills && pillsPrev && pillsNext) {
      pillsPrev.addEventListener('click', () => {
        defaultPills.scrollBy({ left: -240, behavior: 'smooth' });
      });
      pillsNext.addEventListener('click', () => {
        defaultPills.scrollBy({ left: 240, behavior: 'smooth' });
      });
      defaultPills.addEventListener('scroll', updatePillsArrows);
      window.addEventListener('resize', updatePillsArrows);
      updatePillsArrows();
    }
    const categoryGroups = section.querySelectorAll('[data-category-group]');
    const pillSources = {};
    categoryGroups.forEach((group) => {
      const source = group.querySelector('[data-category-pills]');
      if (source) pillSources[group.dataset.categoryGroup] = source;
    });
    let currentPillsKey = 'default';
    const swipers = {};

    const setPillsGroup = (key) => {
      if (key === currentPillsKey || !defaultPills) return;
      const newSource = pillSources[key];
      if (!newSource) return;
      if (currentPillsKey === 'default' && !pillSources.default) {
        const holder = document.createElement('div');
        holder.hidden = true;
        Array.from(defaultPills.children).forEach((btn) => holder.appendChild(btn));
        pillSources.default = holder;
      } else {
        const oldSource = pillSources[currentPillsKey];
        if (oldSource) Array.from(defaultPills.children).forEach((btn) => oldSource.appendChild(btn));
      }
      Array.from(newSource.children).forEach((btn) => defaultPills.appendChild(btn));
      currentPillsKey = key;
      defaultPills.scrollLeft = 0;
      updatePillsArrows();
    };

    const showCategory = (key) => {
      setPillsGroup(key);
      categoryGroups.forEach((group) => {
        group.hidden = group.dataset.categoryGroup !== key;
      });
      const firstPill = defaultPills ? defaultPills.querySelector('.home-filter-slider__pill') : null;
      if (firstPill) activate(firstPill.dataset.filterPill);
    };

    const closeLabelMenu = () => {
      if (!labelDropdown) return;
      labelDropdown.classList.remove('is-open');
      if (labelMenu) labelMenu.hidden = true;
      if (labelToggle) labelToggle.setAttribute('aria-expanded', 'false');
    };

    const activate = (id) => {
      panels.forEach((p) => p.classList.toggle('active', p.dataset.panel === id));
      pills.forEach((pill) => {
        const isActive = pill.dataset.filterPill === id;
        pill.classList.toggle('active', isActive);
        pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      if (swipers[id]) swipers[id].update();
    };

    const selectCategory = (key) => {
      labelOptions.forEach((o) => {
        const isActive = o.dataset.category === key;
        o.classList.toggle('is-selected', isActive);
        o.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      showCategory(key);
    };

    pills.forEach((pill) => {
      pill.addEventListener('click', () => activate(pill.dataset.filterPill));
    });

    if (labelToggle && labelMenu) {
      labelToggle.addEventListener('click', () => {
        const open = labelDropdown.classList.toggle('is-open');
        labelMenu.hidden = !open;
        labelToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      labelOptions.forEach((opt) => {
        opt.addEventListener('click', () => {
          selectCategory(opt.dataset.category);
          closeLabelMenu();
        });
      });
      document.addEventListener('click', (e) => {
        if (!labelDropdown.contains(e.target)) closeLabelMenu();
      });
    }

    const firstCategoryGroup = categoryGroups[0];
    if (firstCategoryGroup) selectCategory(firstCategoryGroup.dataset.categoryGroup);

    if (typeof Swiper !== 'undefined') {
      panels.forEach((panel) => {
        const el = panel.querySelector('.home-filter-slider__swiper');
        if (!el) return;
        swipers[panel.dataset.panel] = new Swiper(el, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          grabCursor: true,
          a11y: { enabled: true },
          breakpoints: {
            768: { spaceBetween: 24 },
          },
          pagination: {
            el: panel.querySelector('.home-filter-slider__pagination'),
            clickable: true,
          },
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-hero]').forEach((section) => {
    const el = section.querySelector('.home-hero__swiper');
    if (!el || typeof Swiper === 'undefined') return;

    const autoplayMs = parseInt(section.dataset.autoplay, 10) || 0;
    const loop = section.dataset.loop === 'true';

    new Swiper(el, {
      slidesPerView: 1,
      loop: loop,
      grabCursor: true,
      a11y: { enabled: true },
      autoHeight: true,
      breakpoints: {
        768: { autoHeight: false },
      },
      autoplay: autoplayMs > 0 ? { delay: autoplayMs, disableOnInteraction: false } : false,
      pagination: {
        el: section.querySelector('.home-hero__pagination'),
        clickable: true,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-ingredients]').forEach((section) => {
    const el = section.querySelector('.home-ingredients__swiper');
    if (!el || typeof Swiper === 'undefined') return;

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      grabCursor: true,
      loop: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      a11y: { enabled: true },
      navigation: {
        prevEl: section.querySelector('.home-ingredients__arrow--prev'),
        nextEl: section.querySelector('.home-ingredients__arrow--next'),
        disabledClass: 'swiper-button-disabled',
      },
      pagination: {
        el: section.querySelector('.home-ingredients__pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 0,
          pagination: { enabled: false },
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-kits"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-kits]').forEach((section) => {
    const tabs = section.querySelectorAll('.home-kits__tab');
    const panels = section.querySelectorAll('.home-kits__panel');
    const dropdown = section.querySelector('[data-kits-select]');
    const toggle = dropdown ? dropdown.querySelector('.home-kits__select-toggle') : null;
    const menu = dropdown ? dropdown.querySelector('.home-kits__select-menu') : null;
    const label = dropdown ? dropdown.querySelector('[data-kits-select-label]') : null;
    const options = dropdown ? dropdown.querySelectorAll('.home-kits__select-option') : [];
    const swipers = {};
    const row2Swipers = {};
    const cta = section.querySelector('[data-kits-cta]');
    const ctaWrap = section.querySelector('.home-kits__cta');
    const ctaLabel = cta ? cta.querySelector('[data-kits-cta-label]') : null;
    const ctaAction = section.dataset.ctaAction || 'expand';
    let activeId = panels.length ? panels[0].dataset.panel : null;
    let expanded = false;
    const loopEnabled = section.dataset.swiperLoop === 'true';
    const autoplayEnabled = section.dataset.swiperAutoplay === 'true';
    const autoplayDelay = parseInt(section.dataset.swiperAutoplayDelay, 10) || 3000;

    const closeMenu = () => {
      if (!dropdown) return;
      dropdown.classList.remove('is-open');
      if (menu) menu.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    };

    const buildSwiper = (el, scope) => {
      return new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        grabCursor: true,
        loop: loopEnabled,
        a11y: { enabled: true },
        navigation: {
          nextEl: scope.querySelector('.home-kits__arrow--next'),
          prevEl: scope.querySelector('.home-kits__arrow--prev'),
        },
        pagination: {
          el: scope.querySelector('.home-kits__pagination'),
          clickable: true,
        },
        autoplay: autoplayEnabled ? { delay: autoplayDelay, disableOnInteraction: false } : false,
        breakpoints: {
          768: {
            spaceBetween: 24,
            pagination: { enabled: false },
          },
        },
      });
    };

    // Row 2 is init'd on first reveal: Swiper needs a visible element to size slides.
    const syncRows = () => {
      if (ctaAction !== 'expand') {
        syncCta();
        return;
      }
      const activePanel = section.querySelector('.home-kits__panel[data-panel="' + activeId + '"]');
      if (expanded && (!activePanel || !activePanel.querySelector('[data-kits-row2]'))) {
        expanded = false;
        section.classList.remove('is-expanded');
        if (ctaLabel && cta) ctaLabel.textContent = cta.dataset.labelMore;
      }
      panels.forEach((panel) => {
        const row = panel.querySelector('[data-kits-row2]');
        if (!row) return;
        const show = expanded && panel.dataset.panel === activeId;
        row.hidden = !show;
        if (!show) return;
        const id = panel.dataset.panel;
        if (!row2Swipers[id] && typeof Swiper !== 'undefined') {
          const el = row.querySelector('.home-kits__swiper--row2');
          if (el) row2Swipers[id] = buildSwiper(el, row);
        }
        const instance = row2Swipers[id];
        if (instance) requestAnimationFrame(() => instance.update());
      });

      syncCta();
    };

    // The CTA either reveals row 2, follows the active tab's collection, or points at a fixed URL.
    const syncCta = () => {
      if (!ctaWrap) return;
      const activePanel = section.querySelector('.home-kits__panel[data-panel="' + activeId + '"]');

      if (ctaAction === 'expand') {
        const hasRow2 = !!(activePanel && activePanel.querySelector('[data-kits-row2]'));
        const url = activePanel ? activePanel.dataset.collectionUrl : '';
        if (cta && url) cta.setAttribute('href', url);
        // Nothing to expand and nowhere to link: only then hide the CTA.
        ctaWrap.hidden = !hasRow2 && !url;
        if (cta) {
          if (hasRow2) {
            cta.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          } else {
            cta.removeAttribute('aria-expanded');
          }
        }
        return;
      }

      if (ctaAction === 'collection') {
        const url = activePanel ? activePanel.dataset.collectionUrl : '';
        if (cta && url) cta.setAttribute('href', url);
        ctaWrap.hidden = !url;
        return;
      }

      ctaWrap.hidden = false;
    };

    const activate = (id) => {
      activeId = id;
      panels.forEach((p) => p.classList.toggle('active', p.dataset.panel === id));
      tabs.forEach((t) => {
        const isActive = t.dataset.panel === id;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      options.forEach((o) => {
        const isActive = o.dataset.panel === id;
        o.classList.toggle('is-selected', isActive);
        o.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive && label) label.textContent = o.textContent.trim();
      });
      if (swipers[id]) {
        const instance = swipers[id];
        requestAnimationFrame(() => {
          if (instance.autoplay) instance.autoplay.stop();
          instance.update();
          if (instance.params.loop) {
            instance.slideToLoop(0, 0, false);
          } else {
            instance.slideTo(0, 0, false);
          }
          if (instance.params.autoplay) instance.autoplay.start();
        });
      }
      syncRows();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.panel));
    });

    if (toggle && menu) {
      toggle.addEventListener('click', () => {
        const open = dropdown.classList.toggle('is-open');
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      options.forEach((opt) => {
        opt.addEventListener('click', () => {
          activate(opt.dataset.panel);
          closeMenu();
        });
      });
      document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) closeMenu();
      });
    }

    if (cta && ctaAction === 'expand') {
      cta.addEventListener('click', (event) => {
        const activePanel = section.querySelector('.home-kits__panel[data-panel="' + activeId + '"]');
        // No second row for this tab: let the anchor navigate to the collection.
        if (!activePanel || !activePanel.querySelector('[data-kits-row2]')) return;
        event.preventDefault();
        expanded = !expanded;
        section.classList.toggle('is-expanded', expanded);
        if (ctaLabel) {
          ctaLabel.textContent = expanded ? cta.dataset.labelLess : cta.dataset.labelMore;
        }
        syncRows();
      });
    }

    if (typeof Swiper !== 'undefined') {
      panels.forEach((panel) => {
        const el = panel.querySelector('.home-kits__swiper:not(.home-kits__swiper--row2)');
        if (!el) return;
        // Row 1 markup precedes row 2, so panel-scoped lookups resolve to row 1's controls.
        swipers[panel.dataset.panel] = buildSwiper(el, panel);
      });
    }

    syncRows();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-quiz-root]').forEach((root) => {
    const steps = Array.from(root.querySelectorAll('.quiz__step'));
    const segs = Array.from(root.querySelectorAll('.quiz__progress-seg'));
    const progress = root.querySelector('[data-quiz-progress]');
    const nextBtn = root.querySelector('.quiz__next');
    const backBtn = root.querySelector('[data-quiz-back]');
    const nextLabelEl = nextBtn.querySelector('.quiz__next-label');
    const nextLabel = nextBtn.getAttribute('data-next-label');
    const finishLabel = nextBtn.getAttribute('data-finish-label');
    const answers = steps.map(() => []);
    const thanks = root.querySelector('[data-quiz-thanks]');
    const recCards = Array.from(root.querySelectorAll('[data-quiz-rec]'));
    let current = 0;
    let finished = false;

    function showStep(index) {
      steps.forEach((step, i) => {
        const hidden = i !== index;
        step.classList.toggle('is-hidden', hidden);
        if (hidden) {
          step.setAttribute('hidden', '');
        } else {
          step.removeAttribute('hidden');
        }
      });
      segs.forEach((seg, i) => seg.classList.toggle('is-active', i <= index));
      if (progress) progress.setAttribute('aria-valuenow', index + 1);
      nextBtn.disabled = answers[index].length === 0;
      nextLabelEl.textContent = index === steps.length - 1 ? finishLabel : nextLabel;
      backBtn.classList.toggle('is-hidden', index === 0);
      backBtn.hidden = index === 0;
    }

    steps.forEach((step, stepIndex) => {
      const options = Array.from(step.querySelectorAll('.quiz__option'));
      options.forEach((option) => {
        option.addEventListener('click', () => {
          const value = option.getAttribute('data-value');
          const wasChecked = option.getAttribute('aria-checked') === 'true';
          option.setAttribute('aria-checked', wasChecked ? 'false' : 'true');
          if (wasChecked) {
            answers[stepIndex] = answers[stepIndex].filter((v) => v !== value);
          } else {
            answers[stepIndex].push(value);
          }
          if (stepIndex === current) nextBtn.disabled = answers[current].length === 0;
        });
      });
    });

    function showResults() {
      finished = true;
      root.classList.add('is-results');
      steps.forEach((step) => step.classList.add('is-hidden'));
      segs.forEach((seg) => seg.classList.add('is-active'));
      if (progress) progress.setAttribute('aria-valuenow', segs.length);
      nextBtn.hidden = true;
      nextBtn.classList.add('is-hidden');
      backBtn.classList.remove('is-hidden');
      backBtn.hidden = false;

      if (thanks) {
        thanks.classList.remove('is-hidden');
        thanks.removeAttribute('hidden');
      }

      const selectedTags = new Set();
      steps.forEach((step) => {
        Array.from(step.querySelectorAll('.quiz__option')).forEach((option) => {
          if (option.getAttribute('aria-checked') === 'true') {
            selectedTags.add(option.getAttribute('data-tag'));
          }
        });
      });

      const scored = recCards.map((card) => {
        const tags = (card.getAttribute('data-tags') || '').split(',').filter(Boolean);
        const score = tags.reduce((count, tag) => count + (selectedTags.has(tag) ? 1 : 0), 0);
        return { card, score };
      });
      scored.sort((a, b) => b.score - a.score);
      scored.forEach((entry, i) => {
        const show = i < 4;
        entry.card.classList.toggle('is-hidden', !show);
        entry.card.classList.toggle('swiper-slide', show);
        if (show) {
          entry.card.removeAttribute('hidden');
        } else {
          entry.card.setAttribute('hidden', '');
        }
      });

      const recSwiperEl = root.querySelector('.quiz__recommendations');
      if (recSwiperEl && recSwiperEl.swiper) {
        recSwiperEl.swiper.destroy(true, true);
      }
      if (recSwiperEl && typeof Swiper !== 'undefined' && window.matchMedia('(max-width: 749px)').matches) {
        const recSwiper = new Swiper(recSwiperEl, {
          slidesPerView: 2,
          spaceBetween: 12,
          grabCursor: true,
          observer: true,
          observeParents: true,
          a11y: { enabled: true },
          pagination: {
            el: recSwiperEl.querySelector('.quiz__recommendations-pagination'),
            clickable: true,
          },
        });
        requestAnimationFrame(() => recSwiper.update());
      }
    }

    function showQuestionStep(index) {
      finished = false;
      root.classList.remove('is-results');
      if (thanks) {
        thanks.classList.add('is-hidden');
        thanks.setAttribute('hidden', '');
      }
      nextBtn.hidden = false;
      nextBtn.classList.remove('is-hidden');
      current = index;
      showStep(current);
    }

    nextBtn.addEventListener('click', () => {
      if (answers[current].length === 0) return;
      if (current < steps.length - 1) {
        current += 1;
        showStep(current);
        return;
      }
      showResults();
    });

    backBtn.addEventListener('click', () => {
      if (finished) {
        showQuestionStep(steps.length - 1);
        return;
      }
      if (current === 0) return;
      current -= 1;
      showStep(current);
    });

    if (steps.length) showStep(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-testimonials]').forEach((section) => {
    const el = section.querySelector('.home-testimonials__swiper');
    if (!el || typeof Swiper === 'undefined') return;
    let instance = null;

    const sync = () => {
      const isMobile = window.matchMedia('(max-width: 1024px)').matches;
      if (isMobile && !instance) {
        instance = new Swiper(el, {
          slidesPerView: 'auto',
          spaceBetween: 16,
          grabCursor: true,
          a11y: { enabled: true },
          pagination: {
            el: section.querySelector('.home-testimonials__pagination'),
            clickable: true,
          },
        });
      } else if (!isMobile && instance) {
        instance.destroy(true, true);
        instance = null;
      }
    };

    sync();
    window.addEventListener('resize', sync);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.main-contact__form').forEach((form) => {
    const submitBtn = form.querySelector('.contact-submit');

    const clearErrors = () => {
      form.querySelectorAll('.error').forEach((el) => el.classList.remove('error'));
      form.querySelectorAll('.js-field-error').forEach((el) => el.remove());
    };

    form.addEventListener('submit', (e) => {
      clearErrors();
      let hasError = false;

      form.querySelectorAll('[required]').forEach((input) => {
        if (input.type === 'checkbox') {
          if (!input.checked) {
            const wrap = input.closest('.contact-privacy');
            if (wrap) wrap.classList.add('error');
            hasError = true;
          }
          return;
        }
        if (!input.value.trim()) {
          input.classList.add('error');
          hasError = true;
        }
      });

      const emailInput = form.querySelector('[name="contact[email]"]');
      if (emailInput && emailInput.value && !/\S+@\S+\.\S+/.test(emailInput.value)) {
        emailInput.classList.add('error');
        hasError = true;
      }

      if (hasError) {
        e.preventDefault();
        const firstError = form.querySelector('.error');
        if (firstError && typeof firstError.focus === 'function') firstError.focus();
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.label = submitBtn.textContent;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-distributors"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dist').forEach((root) => {
    const pills = root.querySelectorAll('.dist-pill');
    const searchInput = root.querySelector('.dist__search-input');
    const cards = root.querySelectorAll('.dist-card');
    const empty = root.querySelector('.dist__empty');
    let activeCity = (root.dataset.defaultCity || '').toLowerCase().trim();
    let query = '';

    function apply() {
      let visible = 0;
      // While the visitor is searching, look up matches across every city instead of
      // restricting to the currently active city pill — otherwise a valid distributor
      // in a different city never renders and the search looks broken.
      const cityMatch = query ? () => true : (card) => !activeCity || card.dataset.city === activeCity;
      cards.forEach((card) => {
        const searchMatch = !query || (card.dataset.search || '').indexOf(query) !== -1;
        const show = cityMatch(card) && searchMatch;
        card.hidden = !show;
        if (show) visible++;
      });
      if (empty) empty.hidden = visible !== 0;
    }

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        pills.forEach((p) => {
          p.classList.remove('is-active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-selected', 'true');
        activeCity = (pill.dataset.city || '').toLowerCase().trim();
        apply();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        query = e.target.value.toLowerCase().trim();
        apply();
      });
    }

    apply();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-grouper-brand"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.grouper-brand').forEach(function (section) {
      var tabs = section.querySelectorAll('.grouper-brand-tab');
      var panels = section.querySelectorAll('.grouper-brand__panel');
      var swipers = {};

      panels.forEach(function (panel) {
        var id = panel.dataset.tabId;
        var swiperEl = panel.querySelector('.swiper');
        if (!swiperEl || typeof Swiper === 'undefined') return;

        swipers[id] = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 16,
          grabCursor: true,
          a11y: { enabled: true },
          navigation: {
            nextEl: panel.querySelector('.grouper-brand__arrow--next'),
            prevEl: panel.querySelector('.grouper-brand__arrow--prev')
          },
          pagination: {
            el: panel.querySelector('.grouper-brand__pagination'),
            clickable: true
          },
          breakpoints: {
            768: {
              slidesPerView: 'auto',
              spaceBetween: 24,
              pagination: { enabled: false }
            }
          }
        });
      });

      function activate(tab) {
        var target = tab.dataset.tabId;
        tabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('active');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        var targetPanel = section.querySelector('.grouper-brand__panel[data-tab-id="' + target + '"]');
        if (targetPanel) {
          targetPanel.classList.add('active');
          if (swipers[target]) swipers[target].update();
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab);
        });
      });

      if (tabs[0]) activate(tabs[0]);
    });

    // Smooth scroll from category cards
    document.querySelectorAll('.grouper-cat-card[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var hash = link.getAttribute('href');
        if (hash === '#') return;
        var target = document.querySelector(hash);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-newsletter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.newsletter-form').forEach((form) => {
    const submitBtn = form.querySelector('.newsletter-form__submit');
    const input = form.querySelector('.newsletter-form__input');

    form.addEventListener('submit', (e) => {
      if (input && (!input.value || !/\S+@\S+\.\S+/.test(input.value))) {
        e.preventDefault();
        input.style.borderColor = '#ff6b6b';
        input.focus();
        return;
      }
      if (submitBtn) submitBtn.disabled = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-point-of-sale-map"] && !Shopify.designMode) return;
  try {
    
  function initPosMap(root) {
    const detailsEl = root.querySelector('.pos-map__select-wrap');
    const heading = root.querySelector('.pos-map__group-heading');
    const wrapper = root.querySelector('.pos-map__grid');
    const cards = Array.from(root.querySelectorAll('.pos-map__grid .pos-location-card'));
    const swiperEl = root.querySelector('.pos-map__swiper');
    const embedWrap = root.querySelector('.pos-map__embed');
    const iframe = root.querySelector('.pos-map__iframe');
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const initialOrder = cards.slice();
    let swiper = null;

    function initSwiper() {
      if (swiper || !swiperEl || typeof Swiper === 'undefined') return;
      swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        grabCursor: true,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        a11y: { enabled: true },
        pagination: {
          el: swiperEl.querySelector('.pos-map__pagination'),
          clickable: true
        }
      });
    }

    function destroySwiper() {
      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
      // Loop mode reorders slides in the DOM; restore the merchant's block order
      // so the desktop grid and the next Swiper init both start from a clean state.
      if (wrapper) initialOrder.forEach((card) => wrapper.appendChild(card));
    }

    // Swiper counts every `.swiper-slide` in the wrapper, even when it is
    // `display: none`. Cards outside the active group must lose the class or
    // they show up as empty slides and extra pagination bullets.
    function applyFilter(group) {
      const visible = [];

      cards.forEach((card) => {
        const isActive = card.dataset.group === group;
        card.hidden = !isActive;
        card.classList.toggle('swiper-slide', isActive);
        if (isActive) visible.push(card);
      });

      return visible;
    }

    function syncSlider() {
      destroySwiper();
      if (mobileQuery.matches) initSwiper();
    }

    function setEmbed(url) {
      if (iframe && iframe.src !== url) iframe.src = url;
      if (embedWrap) embedWrap.hidden = !url;
    }

    function setActiveCard(card) {
      cards.forEach((item) => {
        const isActive = item === card;
        item.classList.toggle('pos-location-card--active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    // Selects a card without scrolling: used for the group's default card, where
    // the visitor did not ask to be moved anywhere.
    function selectCard(card, fallbackEmbed) {
      const embedUrl = (card && card.dataset.embed) || fallbackEmbed || '';
      setActiveCard(card);
      setEmbed(embedUrl);
    }

    // Great-circle distance in km. Good enough to rank cities that are tens or
    // hundreds of km apart.
    function distanceKm(lat1, lng1, lat2, lng2) {
      const toRad = Math.PI / 180;
      const dLat = (lat2 - lat1) * toRad;
      const dLng = (lng2 - lng1) * toRad;
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    // Beyond this the "nearest" city is not a place the visitor can walk into,
    // so the merchant's default group stays.
    const MAX_NEAREST_KM = 300;

    function nearestOption(options, latitude, longitude) {
      let best = null;
      let bestDistance = Infinity;

      options.forEach((option) => {
        const lat = parseFloat(option.dataset.lat);
        const lng = parseFloat(option.dataset.lng);
        if (Number.isNaN(lat) || Number.isNaN(lng)) return;

        const distance = distanceKm(latitude, longitude, lat, lng);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = option;
        }
      });

      if (bestDistance > MAX_NEAREST_KM) return null;
      return best;
    }

    function requestPosition(options, activateOption, visitorPicked) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // The visitor beat the permission prompt: their choice wins.
          if (visitorPicked()) return;

          const option = nearestOption(options, position.coords.latitude, position.coords.longitude);
          if (!option) return;
          if (option.getAttribute('aria-selected') === 'true') return;

          activateOption(option);
        },
        () => {
          /* Denied, unavailable or timed out: the default group is already shown. */
        },
        { timeout: 8000, maximumAge: 600000 }
      );
    }

    function geolocate(options, activateOption, visitorPicked) {
      if (root.dataset.geolocate !== 'true') return;
      if (!navigator.geolocation) return;
      if (!options.some((option) => option.dataset.lat && option.dataset.lng)) return;

      // Skip a pointless prompt when the visitor already said no.
      if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then((status) => {
            if (status.state === 'denied') return;
            requestPosition(options, activateOption, visitorPicked);
          })
          .catch(() => requestPosition(options, activateOption, visitorPicked));
        return;
      }

      requestPosition(options, activateOption, visitorPicked);
    }

    // Liquid already marks the first card of the default group as selected.
    // This only covers the case where that markup is missing or the group changed.
    function selectDefaultCard(visible) {
      const hasActive = cards.some((card) => card.classList.contains('pos-location-card--active') && !card.hidden);
      if (!hasActive) selectCard(visible[0]);
    }

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        if (!card.dataset.embed) return;

        selectCard(card);

        // A moving carousel under the finger after a tap is disorienting.
        if (swiper && swiper.autoplay) swiper.autoplay.stop();

        if (embedWrap) {
          embedWrap.scrollIntoView({
            behavior: reduceMotion.matches ? 'auto' : 'smooth',
            block: 'center'
          });
        }
      });
    });

    if (detailsEl) {
      const options = Array.from(detailsEl.querySelectorAll('.pos-map__select-option'));
      const selected = options.find((option) => option.getAttribute('aria-selected') === 'true');
      const initialGroup = selected ? selected.dataset.group : (cards[0] || {}).dataset?.group;
      let visitorPicked = false;

      if (initialGroup) selectDefaultCard(applyFilter(initialGroup));

      function activateOption(option) {
        const group = option.dataset.group;
        const visible = applyFilter(group);

        if (heading) heading.textContent = group;

        // First card of the new city starts selected; the city-wide embed is
        // only a fallback for a card without a location of its own.
        selectCard(visible[0], option.dataset.embed);

        options.forEach((opt) => {
          opt.setAttribute('aria-selected', opt === option ? 'true' : 'false');
        });
        detailsEl.removeAttribute('open');

        syncSlider();
      }

      options.forEach((option) => {
        option.addEventListener('click', () => {
          visitorPicked = true;
          activateOption(option);
        });
      });

      document.addEventListener('click', (e) => {
        if (!root.isConnected) return;
        if (!detailsEl.contains(e.target)) detailsEl.removeAttribute('open');
      });

      geolocate(options, activateOption, () => visitorPicked);
    } else if (cards.length) {
      selectDefaultCard(applyFilter(cards[0].dataset.group));
    }

    syncSlider();
    mobileQuery.addEventListener('change', syncSlider);
  }

  document.querySelectorAll('.pos-map').forEach(initPosMap);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.pos-map').forEach(initPosMap);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-point-of-sale"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.point-of-sale').forEach((root) => {
    const select = root.querySelector('.point-of-sale__select');
    const pills = root.querySelectorAll('.city-pill');
    const cards = root.querySelectorAll('.point-of-sale__grid .store-card');
    const noResults = root.querySelector('.point-of-sale__no-results');
    const swiperEl = root.querySelector('.point-of-sale__swiper');
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    let swiper = null;

    function updateNoResults() {
      if (!noResults) return;
      const visible = [...cards].some((c) => c.dataset.hidden !== 'true');
      noResults.hidden = visible;
    }

    function filterCards(city) {
      const target = (city || '').toLowerCase();
      cards.forEach((card) => {
        const cardCity = (card.dataset.city || '').toLowerCase();
        card.dataset.hidden = target && cardCity !== target ? 'true' : 'false';
      });
      updateNoResults();
      if (swiper) swiper.update();
    }

    if (select) {
      select.addEventListener('change', (e) => filterCards(e.target.value));
    }

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        pills.forEach((p) => {
          p.classList.remove('is-active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-checked', 'true');
        filterCards(pill.dataset.city);
      });
    });

    function initSwiper() {
      if (swiper || !swiperEl || typeof Swiper === 'undefined') return;
      swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        grabCursor: true,
        pagination: {
          el: swiperEl.querySelector('.point-of-sale__pagination'),
          clickable: true
        }
      });
    }

    function destroySwiper() {
      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
    }

    function handleViewport(mq) {
      if (mq.matches) {
        initSwiper();
      } else {
        destroySwiper();
      }
    }

    handleViewport(mobileQuery);
    mobileQuery.addEventListener('change', handleViewport);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
  document.querySelectorAll('.page-faq').forEach((section) => {
    const triggers = section.querySelectorAll('.accordion-trigger');
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.accordion-item');
        const isOpen = item.classList.contains('open');

        section.querySelectorAll('.accordion-item.open').forEach((el) => {
          el.classList.remove('open');
          const t = el.querySelector('.accordion-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
  function initProductDescription(root) {
    root.querySelectorAll('[data-product-description]').forEach((section) => {
      if (section.dataset.pdpInit === 'true') return;
      section.dataset.pdpInit = 'true';

      let kitsSwiper = null;

      function initKitsSwiper() {
        const el = section.querySelector('.product-description__swiper');
        if (!el || typeof Swiper === 'undefined') return;
        kitsSwiper = new Swiper(el, {
          slidesPerView: 2,
          spaceBetween: 12,
          grabCursor: true,
          a11y: { enabled: true },
          navigation: {
            nextEl: section.querySelector('.product-description__arrow--next'),
            prevEl: section.querySelector('.product-description__arrow--prev')
          },
          pagination: {
            el: section.querySelector('.product-description__pagination'),
            clickable: true
          },
          breakpoints: {
            768: {
              slidesPerView: 4,
              spaceBetween: 24,
              pagination: { enabled: false }
            }
          }
        });
      }

      section.querySelectorAll('[data-product-faq]').forEach((faq) => {
        const collapse = (item) => {
          const content = item.querySelector('.accordion-content');
          const trigger = item.querySelector('.accordion-trigger');
          if (!content) return;
          content.style.height = content.getBoundingClientRect().height + 'px';
          item.classList.remove('open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          requestAnimationFrame(() => {
            content.style.height = '0px';
          });
        };

        const expand = (item) => {
          const content = item.querySelector('.accordion-content');
          const trigger = item.querySelector('.accordion-trigger');
          const body = content && content.querySelector('.accordion-body');
          if (!content) return;
          item.classList.add('open');
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
          content.style.height = (body || content).getBoundingClientRect().height + 'px';

          const duration = parseFloat(getComputedStyle(content).transitionDuration) || 0;
          if (duration === 0) {
            content.style.height = '';
            return;
          }
          const done = (event) => {
            if (event.propertyName !== 'height') return;
            content.style.height = '';
            content.removeEventListener('transitionend', done);
          };
          content.addEventListener('transitionend', done);
        };

        faq.querySelectorAll('.accordion-trigger').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const item = trigger.closest('.accordion-item');
            const isOpen = item.classList.contains('open');
            faq.querySelectorAll('.accordion-item.open').forEach(collapse);
            if (!isOpen) expand(item);
          });
        });
      });

      let modoSwiper = null;

      function initModoSwiper() {
        const el = section.querySelector('.product-modo-slider__swiper');
        if (!el || typeof Swiper === 'undefined') return;
        modoSwiper = new Swiper(el, {
          slidesPerView: 'auto',
          spaceBetween: 20,
          grabCursor: true,
          a11y: { enabled: true },
          pagination: {
            el: section.querySelector('.product-modo-slider__pagination'),
            clickable: true
          }
        });
      }

      initModoSwiper();

      const tabs = Array.from(section.querySelectorAll('.product-description__tab'));
      const panels = Array.from(section.querySelectorAll('.product-description__panel'));

      function applyBg(tab) {
        const bg = tab.dataset.bg && tab.dataset.bg.trim() ? tab.dataset.bg.trim() : section.dataset.defaultBg;
        if (bg) section.style.setProperty('--desc-bg', bg);
      }

      function activate(tab) {
        tabs.forEach((t) => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach((p) => {
          p.classList.remove('active');
          p.hidden = true;
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        const panel = section.querySelector('#' + tab.dataset.tabTarget);
        if (panel) {
          panel.classList.add('active');
          panel.hidden = false;
        }
        applyBg(tab);
        if (kitsSwiper && tab.hasAttribute('data-kits-tab')) kitsSwiper.update();
        if (modoSwiper && panel && panel.querySelector('[data-modo-slider]')) modoSwiper.update();
      }

      const initialActive = section.querySelector('.product-description__tab.active');
      if (initialActive) applyBg(initialActive);

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = tabs[index + 1] || tabs[0];
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = tabs[index - 1] || tabs[tabs.length - 1];
          if (next) {
            event.preventDefault();
            activate(next);
            next.focus();
          }
        });
      });

      const kits = section.querySelector('[data-kits]');
      if (kits && kits.dataset.url) {
        fetch(kits.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const grid = doc.querySelector('[data-kits-grid]');
            const cards = grid ? grid.querySelectorAll('.swiper-slide') : [];
            if (grid && cards.length > 0) {
              kits.innerHTML = grid.innerHTML;
              initKitsSwiper();
              const activeTab = section.querySelector('.product-description__tab.active');
              if (kitsSwiper && activeTab && activeTab.hasAttribute('data-kits-tab')) kitsSwiper.update();
            } else {
              const tab = section.querySelector('[data-kits-tab]');
              const kitsPanel = kits.closest('.product-description__panel');
              const wasActive = kitsPanel && kitsPanel.classList.contains('active');
              if (tab) tab.remove();
              if (kitsPanel) kitsPanel.remove();
              if (wasActive) {
                const firstTab = section.querySelector('.product-description__tab');
                if (firstTab) activate(firstTab);
              }
            }
          })
          .catch(() => {});
      }
    });
  }

  initProductDescription(document);
  document.addEventListener('shopify:section:load', (event) => initProductDescription(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    const mainEl = gallery.querySelector('[data-gallery-main]');
    const thumbsEl = gallery.querySelector('[data-gallery-thumbs]');
    const slides = mainEl ? Array.from(mainEl.querySelectorAll('.product-gallery__main-image')) : [];
    const thumbs = Array.from(gallery.querySelectorAll('.product-gallery__thumb'));
    const swatches = Array.from(gallery.querySelectorAll('.product-gallery__swatch-circle'));
    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

    if (typeof Swiper !== 'undefined' && thumbsEl) {
      new Swiper(thumbsEl, {
        direction: 'vertical',
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchOverflow: true,
        observer: true,
        resizeObserver: true,
        a11y: { enabled: true },
        navigation: {
          nextEl: gallery.querySelector('[data-thumbs-next]'),
          prevEl: gallery.querySelector('[data-thumbs-prev]'),
        },
      });
    }

    let swiper = null;
    function initSwiper() {
      if (typeof Swiper === 'undefined' || !mainEl) return;
      if (isMobile() && !swiper) {
        swiper = new Swiper(mainEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          a11y: { enabled: true },
          pagination: { el: gallery.querySelector('.product-gallery__pagination'), clickable: true },
          on: {
            slideChange: (s) => showImage(s.activeIndex),
          },
        });
      } else if (!isMobile() && swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
    }
    initSwiper();
    window.addEventListener('resize', initSwiper);

    function showImage(index) {
      thumbs.forEach((t) => t.classList.toggle('active', t.dataset.thumbIndex == index));
      swatches.forEach((s) => s.classList.toggle('active', s.dataset.thumbIndex == index));
      if (slides.length && slides[index]) {
        // Desktop: replace the visible main image content
        slides.forEach((s, i) => (s.parentElement.style.display = i === Number(index) ? '' : isMobile() ? '' : 'none'));
      }
    }
    // On desktop, only show the active slide; mobile uses swiper.
    if (!isMobile()) showImage(0);

    thumbs.concat(swatches).forEach((el) => {
      el.addEventListener('click', () => {
        const idx = Number(el.dataset.thumbIndex);
        if (swiper) swiper.slideTo(idx);
        showImage(idx);
      });
    });

    // Variant change → swap to matching featured image index handled by product-info.

    // Lightbox
    const lightbox = document.querySelector('[data-gallery-lightbox]');
    if (lightbox) {
      const lbImg = lightbox.querySelector('.gallery-lightbox__image');
      const closeBtn = lightbox.querySelector('[data-lightbox-close]');
      let lastFocus = null;

      function openLightbox(src, alt) {
        lbImg.src = src;
        lbImg.alt = alt || '';
        lastFocus = document.activeElement;
        lightbox.classList.add('open');
        closeBtn.focus();
      }
      function closeLightbox() {
        lightbox.classList.remove('open');
        if (lastFocus) lastFocus.focus();
      }

      if (!isMobile()) {
        mainEl &&
          mainEl.addEventListener('click', (e) => {
            if (e.target.closest('.product-gallery__wishlist')) return;
            const active = slides.find((s) => s.parentElement.style.display !== 'none') || slides[0];
            if (active) openLightbox(active.src, active.alt);
          });
      }
      closeBtn.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && lightbox.classList.contains('open')) closeLightbox();
      });
    }

    // Mobile: arrow scrolls the swatches row to reveal remaining thumbnails
    const swatchesRow = gallery.querySelector('[data-swatches-row]');
    const swatchesArrow = gallery.querySelector('[data-swatches-arrow]');
    swatchesArrow &&
      swatchesRow &&
      swatchesArrow.addEventListener('click', () => {
        swatchesRow.scrollBy({ left: swatchesRow.clientWidth * 0.8, behavior: 'smooth' });
      });

    // Wishlist toggle (visual)
    const wishlist = gallery.querySelector('.product-gallery__wishlist');
    wishlist &&
      wishlist.addEventListener('click', () => {
        wishlist.classList.toggle('active');
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.product-info');
    if (!section) return;

    const form = section.querySelector('.product-form');
    const select = section.querySelector('[name="id"]');
    const variantData = JSON.parse(section.querySelector('[data-variants]').textContent || '[]');
    const i18nEl = section.querySelector('[data-i18n]');
    const i18n = i18nEl ? JSON.parse(i18nEl.textContent || '{}') : {};

    function fmtMoney(cents) {
      return '$' + (cents / 100).toLocaleString('es-CO');
    }

    // Resolve selected option buttons → matching variant
    function selectedOptions() {
      const opts = {};
      section.querySelectorAll('.swatch.active, .size-tab.active').forEach((el) => {
        if (el.dataset.optionName) opts[el.dataset.optionName] = el.dataset.optionValue;
      });
      return opts;
    }

    // Option buttons
    section.querySelectorAll('.swatch').forEach((sw) => {
      sw.addEventListener('click', () => {
        if (sw.disabled) return;
        const group = sw.closest('.product-info__swatches') || section;
        group.querySelectorAll('.swatch').forEach((s) => {
          s.classList.remove('active');
          s.setAttribute('aria-checked', 'false');
        });
        sw.classList.add('active');
        sw.setAttribute('aria-checked', 'true');
        const row = sw.closest('.product-info__option-row');
        const selectedLabel = row ? row.querySelector('[data-option-selected]') : null;
        if (selectedLabel) selectedLabel.textContent = sw.dataset.optionValue;
        updateVariant();
      });
    });
    section.querySelectorAll('.size-tab').forEach((tab) => {
      tab.addEventListener('click', () => {
        if (tab.disabled) return;
        const group = tab.closest('.product-info__sizes') || section;
        group.querySelectorAll('.size-tab').forEach((t) => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        updateVariant();
      });
    });

    function updateVariant() {
      const opts = selectedOptions();
      const values = Object.values(opts);
      const variant = variantData.find((v) => values.every((val) => v.options.indexOf(val) !== -1)) || variantData[0];
      if (!variant) return;
      if (select) {
        select.value = variant.id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const priceEl = section.querySelector('.product-info__price');
      if (priceEl) priceEl.textContent = fmtMoney(variant.price);

      const compareEl = section.querySelector('.product-info__price-compare');
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = fmtMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      const atc = section.querySelector('.product-info__atc');
      if (atc) {
        atc.disabled = !variant.available;
        const atcLabel = atc.querySelector('.product-info__atc-label');
        if (atcLabel) atcLabel.textContent = variant.available ? i18n.add_to_cart : i18n.sold_out;
      }

      // Swap gallery image if variant has a featured image
      if (variant.featured_image && variant.featured_image.src) {
        document.querySelectorAll('.product-gallery__main-image').forEach((img, i) => {
          if (i === 0) img.src = variant.featured_image.src;
        });
      }
    }

    // Quantity stepper
    const stepper = section.querySelector('.qty-stepper');
    if (stepper) {
      const minus = stepper.querySelector('.qty-stepper__btn--minus');
      const plus = stepper.querySelector('.qty-stepper__btn--plus');
      const value = stepper.querySelector('.qty-stepper__value');
      const input = stepper.querySelector('[name="quantity"]');
      minus.addEventListener('click', () => {
        const n = Math.max(1, parseInt(value.textContent, 10) - 1);
        value.textContent = n;
        input.value = n;
        minus.disabled = n <= 1;
      });
      plus.addEventListener('click', () => {
        const n = parseInt(value.textContent, 10) + 1;
        value.textContent = n;
        input.value = n;
        minus.disabled = false;
      });
    }

    // ATC submit → /cart/add.js
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('.product-info__atc');
        if (!btn || btn.disabled) return;
        const label = btn.querySelector('.product-info__atc-label') || btn;
        const original = label.textContent;
        btn.classList.add('loading');
        label.textContent = i18n.adding;
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
          if (!res.ok) throw new Error('add failed');
          label.textContent = i18n.added;
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { productId: section.dataset.productId } }));
          setTimeout(() => {
            label.textContent = original;
            btn.classList.remove('loading');
          }, 2000);
        } catch (err) {
          label.textContent = i18n.add_error;
          btn.classList.remove('loading');
          setTimeout(() => { label.textContent = original; }, 2500);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-reviews__item .accordion-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const isOpen = item.classList.toggle('open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const stickyBar = document.querySelector('.product-sticky-bar');
    if (!stickyBar) return;

    // Static at page top; pin to top:0 once its natural position scrolls past the viewport top.
    // A spacer preserves layout height while the bar is fixed so content doesn't jump.
    const spacer = document.createElement('div');
    spacer.className = 'product-sticky-bar__spacer';
    stickyBar.parentNode.insertBefore(spacer, stickyBar);

    let pinned = false;
    let naturalTop = 0;

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function measure() {
      if (!pinned) {
        naturalTop = spacer.getBoundingClientRect().top + window.scrollY;
      }
    }

    function update() {
      if (isMobile()) {
        stickyBar.classList.add('pinned');
        pinned = true;
        spacer.style.height = '0px';
        return;
      }
      if (!pinned && window.scrollY > naturalTop) {
        spacer.style.height = stickyBar.offsetHeight + 'px';
        stickyBar.classList.add('pinned');
        pinned = true;
      } else if (pinned && window.scrollY <= naturalTop) {
        stickyBar.classList.remove('pinned');
        spacer.style.height = '0px';
        pinned = false;
        measure();
      }
    }

    measure();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', () => {
      measure();
      update();
    });

    const mainForm = document.querySelector('.product-form');
    const mainSelect = mainForm ? mainForm.querySelector('[name="id"]') : null;

    function escapeAttr(value) {
      return window.CSS && CSS.escape ? CSS.escape(value) : value.replace(/"/g, '\\"');
    }

    // Clicking a sticky option delegates to the matching main control (matched
    // by BOTH option name and value, so two options sharing a value string —
    // e.g. a color and a flavor both named "Rojo" — never cross-trigger) so
    // the product form runs its own variant logic — single source of truth.
    function bindOption() {
      stickyBar.querySelectorAll('button[data-option-name][data-option-value]').forEach((el) => {
        el.addEventListener('click', () => {
          const main = document.querySelector(
            '.product-info [data-option-name="' + escapeAttr(el.dataset.optionName) + '"][data-option-value="' + escapeAttr(el.dataset.optionValue) + '"]'
          );
          if (main) main.click();
        });
      });
    }
    bindOption();

    // Mirror the active option state from the main controls into the sticky bar.
    function reflectActive() {
      stickyBar.querySelectorAll('button[data-option-name][data-option-value]').forEach((el) => {
        const main = document.querySelector(
          '.product-info [data-option-name="' + escapeAttr(el.dataset.optionName) + '"][data-option-value="' + escapeAttr(el.dataset.optionValue) + '"]'
        );
        el.classList.toggle('active', !!(main && main.classList.contains('active')));
        if (el.getAttribute('role') === 'option') {
          el.setAttribute('aria-selected', el.classList.contains('active') ? 'true' : 'false');
        } else if (el.getAttribute('role') === 'radio') {
          el.setAttribute('aria-checked', el.classList.contains('active') ? 'true' : 'false');
        }
      });

      stickyBar.querySelectorAll('.sticky-bar__dropdown').forEach((dropdown) => {
        const activeOption = dropdown.querySelector('.sticky-bar__dropdown-option.active');
        const valueEl = dropdown.querySelector('[data-dropdown-value]');
        if (activeOption && valueEl) valueEl.textContent = activeOption.textContent.trim();
      });
    }

    // Quantity stepper (zero-padded to match the design). The sticky buttons
    // delegate to the main stepper — same single-source-of-truth pattern as
    // the option controls — then both directions re-read the main value so
    // the bar stays in sync whether the shopper used the bar or the buybox.
    const qtyValue = stickyBar.querySelector('.sticky-bar__qty-value');
    const qtyMinus = stickyBar.querySelector('.sticky-bar__qty-btn--minus');
    const qtyPlus = stickyBar.querySelector('.sticky-bar__qty-btn--plus');
    const mainQtyMinus = mainForm ? mainForm.querySelector('.qty-stepper__btn--minus') : null;
    const mainQtyPlus = mainForm ? mainForm.querySelector('.qty-stepper__btn--plus') : null;
    const mainQtyValue = mainForm ? mainForm.querySelector('.qty-stepper__value') : null;
    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }
    function syncQtyFromMain() {
      if (!mainQtyValue) return;
      const n = parseInt(mainQtyValue.textContent, 10) || 1;
      if (qtyValue) qtyValue.textContent = pad(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
    }
    qtyMinus &&
      mainQtyMinus &&
      qtyMinus.addEventListener('click', () => {
        mainQtyMinus.click();
        syncQtyFromMain();
      });
    qtyPlus &&
      mainQtyPlus &&
      qtyPlus.addEventListener('click', () => {
        mainQtyPlus.click();
        syncQtyFromMain();
      });
    mainQtyMinus && mainQtyMinus.addEventListener('click', syncQtyFromMain);
    mainQtyPlus && mainQtyPlus.addEventListener('click', syncQtyFromMain);
    syncQtyFromMain();

    // Mobile swatch panel disclosure toggle (one per color/aroma group)
    stickyBar.querySelectorAll('[data-sticky-swatch-group]').forEach((group) => {
      const swatchToggle = group.querySelector('.sticky-bar__color-toggle');
      const swatchPanel = group.querySelector('.sticky-bar__swatches');
      if (!swatchToggle || !swatchPanel) return;
      swatchToggle.addEventListener('click', () => {
        const isOpen = swatchPanel.classList.toggle('is-open');
        swatchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      swatchPanel.addEventListener('click', (event) => {
        if (event.target.closest('.sticky-bar__swatch')) {
          swatchPanel.classList.remove('is-open');
          swatchToggle.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // Generic option dropdown (long/many values): custom listbox, open/close + outside-click/Escape dismiss
    stickyBar.querySelectorAll('.sticky-bar__dropdown').forEach((dropdown) => {
      const trigger = dropdown.querySelector('.sticky-bar__dropdown-trigger');
      const panel = dropdown.querySelector('.sticky-bar__dropdown-panel');
      if (!trigger || !panel) return;

      function closeDropdown() {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
      function openDropdown() {
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      trigger.addEventListener('click', () => {
        panel.classList.contains('is-open') ? closeDropdown() : openDropdown();
      });

      panel.addEventListener('click', (event) => {
        if (event.target.closest('.sticky-bar__dropdown-option')) closeDropdown();
      });

      document.addEventListener('click', (event) => {
        if (!dropdown.contains(event.target)) closeDropdown();
      });

      dropdown.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeDropdown();
          trigger.focus();
        }
      });
    });

    // ATC: trigger the main form submit so the same logic runs
    const stickyAtc = stickyBar.querySelector('[data-sticky-atc]');
    stickyAtc &&
      stickyAtc.addEventListener('click', () => {
        if (mainForm) {
          mainForm.requestSubmit
            ? mainForm.requestSubmit()
            : mainForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });

    // Keep sticky price + active options in sync with variant changes
    if (mainSelect) {
      mainSelect.addEventListener('change', () => {
        const priceEl = document.querySelector('.product-info__price');
        const stickyPrice = stickyBar.querySelector('.sticky-bar__price');
        if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent;
        reflectActive();
      });
    }

    // Gift progress — same threshold/messages as the cart drawer (values in cents)
    function updateShippingProgress(cartTotalCents) {
      const threshold = parseInt(stickyBar.dataset.threshold || '0', 10);
      const text = stickyBar.querySelector('.sticky-bar__shipping-text');
      if (!threshold || !text) return;
      const pct = Math.min((cartTotalCents / threshold) * 100, 100);
      const fill = stickyBar.querySelector('.sticky-bar__progress-fill');
      if (fill) fill.style.width = pct + '%';
      const remaining = Math.max(threshold - cartTotalCents, 0);
      if (remaining > 0) {
        const amount = '$' + Math.round(remaining / 100).toLocaleString('es-CO');
        text.innerHTML = text.dataset.template.replace('{{ amount }}', '<strong>' + amount + '</strong>');
      } else {
        text.textContent = text.dataset.success;
      }
    }

    document.addEventListener('cart:updated', () => {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => updateShippingProgress(cart.total_price))
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-articles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-related-swiper]').forEach((el) => {
    function initSwiper() {
      if (typeof Swiper === 'undefined') {
        return false;
      }
      new Swiper(el, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        pagination: { el: el.querySelector('.swiper-pagination'), clickable: true }
      });
      return true;
    }

    if (!initSwiper()) {
      let tries = 0;
      const timer = setInterval(() => {
        tries += 1;
        if (initSwiper() || tries > 20) {
          clearInterval(timer);
        }
      }, 150);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.related-products').forEach((section) => {
    function initSlider() {
      const el = section.querySelector('.related-products__swiper');
      if (!el || typeof Swiper === 'undefined' || el.dataset.inited) return;
      el.dataset.inited = 'true';
      new Swiper(el, {
        slidesPerView: 2,
        spaceBetween: 12,
        grabCursor: true,
        loop: true,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        a11y: { enabled: true },
        navigation: {
          nextEl: section.querySelector('.related-products__arrow--next'),
          prevEl: section.querySelector('.related-products__arrow--prev')
        },
        pagination: {
          el: section.querySelector('.related-products__pagination'),
          clickable: true
        },
        breakpoints: {
          768: { slidesPerView: 3.5, spaceBetween: 24 }
        }
      });
    }

    // Load Shopify recommendations client-side if no metafield products rendered
    const container = section.querySelector('.related-products__container');
    if (container && container.querySelector('.related-products__placeholder')) {
      const pid = section.dataset.productId;
      const sectionId = section.dataset.sectionId;
      const limit = section.dataset.limit || 8;
      fetch(`/recommendations/products?section_id=${sectionId}&product_id=${pid}&limit=${limit}&intent=related`)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const cards = doc.querySelectorAll('.product-card');
          if (!cards.length) return;
          const swiper = document.createElement('div');
          swiper.className = 'swiper related-products__swiper';
          const wrap = document.createElement('div');
          wrap.className = 'swiper-wrapper';
          cards.forEach((card) => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide related-products__slide';
            slide.appendChild(card);
            wrap.appendChild(slide);
          });
          swiper.appendChild(wrap);
          const pag = document.createElement('div');
          pag.className = 'swiper-pagination related-products__pagination';
          swiper.appendChild(pag);
          container.innerHTML = '';
          container.appendChild(swiper);
          initSlider();
        })
        .catch(() => {});
    } else {
      initSlider();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stores-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.stores-slider').forEach((section) => {
    const el = section.querySelector('.stores-slider__swiper');
    if (!el || typeof Swiper === 'undefined') return;

    new Swiper(el, {
      slidesPerView: 1.1,
      spaceBetween: 16,
      grabCursor: true,
      loop: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      a11y: { enabled: true },
      pagination: {
        el: section.querySelector('.stores-slider__pagination'),
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          spaceBetween: 24
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-badges"] && !Shopify.designMode) return;
  try {
    
  function initTrustBadges(container) {
    const el = container.querySelector('.trust-badges__swiper');
    if (!el || typeof Swiper === 'undefined') return;

    new Swiper(el, {
      slidesPerView: 3.2,
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      centerInsufficientSlides: true,
      a11y: { enabled: true },
      pagination: {
        el: container.querySelector('.trust-badges__pagination'),
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 20
        }
      }
    });
  }

  document.querySelectorAll('[data-trust-badges]').forEach(initTrustBadges);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'dlunchi:wishlist';
    var section = document.querySelector('[data-wishlist-section]');
    if (!section) return;

    var grid = section.querySelector('[data-wishlist-grid]');
    var emptyState = section.querySelector('[data-wishlist-empty]');
    var moneyFormat = section.getAttribute('data-money-format') || '';
    var removeLabel = section.getAttribute('data-remove-label') || '';

    function getWishlist() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {
        return [];
      }
    }

    function setWishlist(handles) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    }

    function removeHandle(handle) {
      setWishlist(getWishlist().filter(function (h) { return h !== handle; }));
    }

    function withComma(value) {
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }

    function withApostrophe(value) {
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      return parts.join('.');
    }

    function formatMoney(cents) {
      var decimals = cents % 100 === 0 ? String(Math.round(cents / 100)) : (cents / 100).toFixed(2);
      var noDecimals = String(Math.round(cents / 100));

      if (!moneyFormat || moneyFormat.indexOf('amount') === -1) {
        return '$' + decimals;
      }

      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withComma(noDecimals))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma(decimals))
        .replace(/\{\{\s*amount_no_decimals_with_apostrophe_separator\s*\}\}/, withApostrophe(noDecimals))
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, withApostrophe(decimals))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/, decimals);
    }

    function renderEmpty() {
      grid.hidden = true;
      emptyState.hidden = false;
    }

    function buildCard(product) {
      var image = product.featured_image || (product.images && product.images[0]);
      var article = document.createElement('article');
      article.className = 'product-card';
      article.innerHTML =
        '<div class="product-card__media">' +
          '<a class="product-card__image-link" href="/products/' + product.handle + '">' +
            '<div class="product-card__image-wrap">' +
              (image
                ? '<img class="product-card__image product-card__image--primary" src="' + image + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy">'
                : '') +
            '</div>' +
          '</a>' +
          '<button type="button" class="product-card__wishlist active" aria-pressed="true" data-wishlist-toggle data-product-handle="' + product.handle + '" aria-label="' + removeLabel + '">' +
            '<svg class="product-card__wishlist-icon product-card__wishlist-icon--idle" width="31" height="22" viewBox="0 0 31 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15.6274 21.2637C9.99595 18.8716 -1.78186 13.4229 0.228176 6.01398C1.05877 2.94078 3.99907 1.06364 7.08888 0.731402C10.9761 0.316105 14.3483 2.17663 17.2886 4.6518C18.983 1.22976 22.6708 -1.07929 26.1759 0.515448C30.3123 2.37598 31.1262 7.60871 28.9169 11.4461C26.8238 15.0674 23.8004 17.8416 20.5943 20.5327C19.2321 21.679 17.4713 22.0278 15.644 21.2471L15.6274 21.2637ZM17.9696 20.1673C22.6376 16.6622 31.2093 9.5523 27.0231 3.40591C25.9433 1.82779 24.033 1.19653 22.2555 2.07696C18.2853 4.02055 19.1823 7.99079 17.0062 7.39276C14.5808 4.087 10.7269 1.79456 6.5573 2.50887C4.51404 2.85772 2.73657 4.46907 2.23821 6.06381C0.145117 12.6421 12.5708 18.4563 17.9696 20.1673Z" fill="currentColor"/></svg>' +
            '<svg class="product-card__wishlist-icon product-card__wishlist-icon--active" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path class="product-card__wishlist-bubble" d="M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z"/><path class="product-card__wishlist-heart" d="M23.0553 34.1197C17.6051 31.7957 6.17002 26.5306 8.12386 19.3322C8.92596 16.3501 11.7847 14.5196 14.7669 14.2111C18.5306 13.7998 21.8213 15.6097 24.6595 18.016C26.3048 14.7047 29.8835 12.463 33.277 14.0055C37.2875 15.8153 38.0896 20.8748 35.9301 24.6179C33.894 28.1348 30.9529 30.8085 27.8473 33.441C26.5311 34.5516 24.824 34.9013 23.0347 34.1403L23.0553 34.1197Z"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="product-card__info">' +
          '<a class="product-card__title-link" href="/products/' + product.handle + '">' +
            '<h3 class="product-card__title">' + product.title + '</h3>' +
          '</a>' +
          '<div class="product-card__footer">' +
            '<div class="product-card__price-wrap">' +
              '<span class="product-card__price">' + formatMoney(product.price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
      return article;
    }

    function removeCard(handle) {
      var card = grid.querySelector('[data-product-handle="' + handle + '"]');
      if (!card) return;
      var article = card.closest('.product-card');
      if (article) article.remove();
      if (!grid.children.length) renderEmpty();
    }

    grid.addEventListener('click', function (event) {
      var button = event.target.closest('[data-wishlist-toggle]');
      if (!button) return;
      var handle = button.getAttribute('data-product-handle');
      removeHandle(handle);
      removeCard(handle);
    });

    var handles = getWishlist();
    if (!handles.length) {
      renderEmpty();
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      var validHandles = valid.map(function (p) { return p.handle; });

      if (validHandles.length !== handles.length) {
        setWishlist(validHandles);
      }

      if (!valid.length) {
        renderEmpty();
        return;
      }

      valid.forEach(function (product) {
        grid.appendChild(buildCard(product));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
